import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import Mobilemenu from "../../layouts/mobile-menu";
import React, { useEffect, useRef, useState } from 'react';
import Select, { createFilter } from 'react-select';
import PoliceReportModal from "./modals/edit-police-report";
import LpoModal from "./modals/edit-lpo";
import InoviceModal from "./modals/edit-invoice";
import DrivingLicenseModal from "./modals/edit-driving-licence";
import { styleSelect } from "../../constants/customStyles";
import { getAllState } from "../../actions/StateAction";
import { getAllVehicleCode } from "../../actions/VehicleCodeActions";
import { getAllVehicle } from "../../actions/VehicleActions";
import { useDispatch, useSelector } from "react-redux";
import { getAllInsuranceCompany } from "../../actions/InsuranceCompanyActions";
import { useParams } from "react-router";
import { getEstimateById } from "../../actions/EstimateActions";
import { getJobCardByEstimateId, getJobLatestId, saveJobCard, savePerformaInvoice, generatePurchaseOrders } from "../../actions/JobCardActions";
import AddProduct from "../Investigation/addProductModal";
import { getAllProductCategory } from "../../actions/ProductCategoryActions";
import { getAllProduct } from "../../actions/ProductActions";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import Toast from "../../components/Toast";
import { saveLpo } from "../../actions/LpoActions";
import { savePoliceReport } from "../../actions/PoliceReportActions";
import { getAllPoliceStation } from "../../actions/PoliceStationActions";
import { saveDrivingLicense } from "../../actions/DrivingLicenseActions";
import Dropzone, { useDropzone } from 'react-dropzone';
import { Swiper, SwiperSlide } from "swiper/react";
import { Grid, Scrollbar } from "swiper";
import { ThreeDots } from "react-loader-spinner";
import { getAllSupplier } from "../../actions/SupplierActions";
import { Modal } from "react-bootstrap";
import EditVehicleModal from "./modals/edit-vehicle";
import EditCustomerModal from "./modals/edit-customer";
import { getAllInsuranceType } from "../../actions/InsuranceTypeActions";
import SignatureCanvas from 'react-signature-canvas'

// import styled from 'styled-components';
// const GaugeContainer = styled.div`
//   /* CSS styles for the gauge container */`;

// const GaugeNeedle = styled.div`
//   /* CSS styles for the gauge needle */
//   transform: rotate(${props => props.angle}deg);`;


function AddJobCard() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();

    // params)

    // const [fuelLevel, setFuelLevel] = useState(0);

    // const handleFuelLevelChange = event => {
    //     setFuelLevel(event.target.value);
    // };

    const [contractorId, setContractorId] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [typeId, setTypeId] = useState('');
    const [jobIn, setJobIn] = useState({
        'date': moment().format('YYYY-MM-DD'),
        'time': moment().format('HH:mm:ss'),
        'start_on': moment().format('YYYY-MM-DD'),
        'estimateId': params.estimate_id ? params.estimate_id : null
    });
    const [jobOut, setJobOut] = useState({});
    const [document, setDocument] = useState({});
    const [details, setDetails] = useState({});
    const [estimateId, setEstimateId] = useState(params.estimate_id ? params.estimate_id : null);
    const [estimateDetails, setEstimateDetails] = useState({});
    const [product, setProduct] = useState('');
    const [Category, setProductCategory] = useState('');
    const [jobCardNo, setJobCardNo] = useState('');
    const [jobCardNoShow, setJobCardNoShow] = useState('');
    const [documentShow, setDocumentShow] = useState(false);
    const [detailShow, setDetailShow] = useState(false);
    const [jobOutShow, setJobOutShow] = useState(false);
    const [selectedPolice, setSelectedPolice] = useState('');
    const [estimatedPrice, setEstimatePrice] = useState('');
    const [discounts, setDiscounts] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [selectedPayType, setSelectedPayType] = useState('');
    const [previewImages, setPreviewImages] = useState([]);
    const [previewImagesPoliceReport, setPreviewImagesPoliceReport] = useState([]);
    const [previewImagesDrivingLicense, setPreviewImagesDrivingLicense] = useState([]);
    const [previewImagesJobOut, setPreviewImagesJobOut] = useState([]);

    useEffect(() => {
        dispatch(getEstimateById(estimateId));
        // if (estimateId) {
        //     dispatch(getEstimateById(estimateId));
        // }
    }, [estimateId])

    useEffect(() => {
        // dispatch(getJobLatestId());
        dispatch(getAllVehicle(9999, '', ''));
        dispatch(getAllInsuranceCompany(null, 9999, { status: 1 }));
        dispatch(getAllProductCategory(null, 9999, ''));
        dispatch(getAllProduct(null, 9999999, ''));
        dispatch(getAllSupplier(null, 9999999, ''));
        dispatch(getAllInsuranceType(null, 9999999, { status: 1 }));
    }, []);

    const insuranceCompanies = useSelector(state => state?.insuranceCompany?.insuranceCompanies?.data);
    const policeReportId = useSelector(state => state?.policeReport?.policeReportId);
    const drivingLicenseId = useSelector(state => state?.drivingLicense?.drivingLicenseId);
    const LpoId = useSelector(state => state?.Lpo?.LpoId);
    const productCategories = useSelector(state => state?.productCategory?.productCategories?.data);
    const products = useSelector(state => state?.product?.products?.data);
    const addEditLoading = useSelector(state => state?.loading?.addEditLoading);
    const loading = useSelector(state => state?.loading?.loading);
    const JobId = '';
    const savedJobCard = useSelector(state => state?.jobCard?.savedJobCard);
    const user_id = JSON.parse(localStorage.getItem('user'));
    const user_permissions = JSON.parse(localStorage.getItem('perm'));
    const suppliers = useSelector(state => state?.supplier?.suppliers?.data);
    const insuranceTypes = useSelector(state => state?.insuranceType?.insuranceTypes?.data);
    // const estimate = useSelector(state => state?.estimate?.estimate);

    const estimate = useSelector(state => state?.estimate?.estimate);

    useEffect(() => {
        // if (savedJobCard && Object.keys(savedJobCard).length == 0) {
        if (estimate && estimate.job_card_details) {
            dispatch(getJobCardByEstimateId(estimateId));
        }
        // }
    }, [estimate])

    useEffect(() => {
        if (estimateDetails.images && Object.keys(estimateDetails.images).length > 0) {
            const preloadImages = estimateDetails.images.reduce((accumulator, image) => {
                const imageObject = {
                    preview: image.image_path + '/' + image.file_name,
                    default: 0,
                    id: image.job_card_image_id,
                };
                if (image.type === 'jobIn') {
                    return { ...accumulator, files: [...accumulator.files, imageObject] };
                } else if (image.type === 'jobOut') {
                    return { ...accumulator, jobOutFiles: [...accumulator.jobOutFiles, imageObject] };
                }
                return accumulator;
            }, { files: [], jobOutFiles: [] });
            setFiles(preloadImages ? preloadImages?.files : '');
            setPreviewImages(preloadImages ? preloadImages?.files : '');
            setJobOutFiles(preloadImages ? preloadImages?.jobOutFiles : '');
            setPreviewImagesJobOut(preloadImages ? preloadImages?.jobOutFiles : '');
        } else {
            setFiles([]);
            setPreviewImages([]);
            setJobOutFiles([]);
            setPreviewImagesJobOut([]);
        }
    }, [estimateDetails]);

    useEffect(() => {
        if (estimateDetails?.police_report && Object.keys(estimateDetails?.police_report?.images).length > 0) {
            let preloadImages = [];
            estimateDetails?.police_report?.images.forEach(function (image, index) {
                preloadImages.push({ preview: image.image_path + '/' + image.file_name, default: 0, id: image.police_report_image_id });
            })
            setPoliceReportFiles(preloadImages);
            setPreviewImagesPoliceReport(preloadImages);
        } else {
            setPoliceReportFiles([]);
            setPreviewImagesPoliceReport([]);
        }
    }, [estimateDetails?.police_report?.images])

    useEffect(() => {
        if (estimateDetails?.driving_license && Object.keys(estimateDetails?.driving_license?.images).length > 0) {
            let preloadImages = [];
            estimateDetails?.driving_license?.images.forEach(function (image, index) {
                preloadImages.push({ preview: image.image_path + '/' + image.file_name, default: 0, id: image.driving_license_image_id });
            })
            setDrivingLicenseFiles(preloadImages);
            setPreviewImagesDrivingLicense(preloadImages);
        } else {
            setDrivingLicenseFiles([]);
            setPreviewImagesDrivingLicense([]);
        }
    }, [estimateDetails?.driving_license?.images])

    useEffect(() => {
        if (policeReportId && Object.keys(policeReportId).length > 0) {
            setDocument({
                ...document,
                police_report_id: policeReportId.police_report_id ?? null,
                customer_id: customerId,
                estimate_id: estimateId,
                job_card_id: estimateDetails?.job_card_id,
            });
        }
    }, [policeReportId])
    // document)

    useEffect(() => {
        if (Object.keys(drivingLicenseId).length > 0) {
            setDocument({
                ...document,
                driving_license_id: drivingLicenseId.driving_license_id ?? null,
                customer_id: customerId,
                estimate_id: estimateId,
                job_card_id: estimateDetails?.job_card_id,

            });
        }
    }, [drivingLicenseId])

    useEffect(() => {
        if (Object.keys(LpoId).length > 0) {
            setDocument({
                ...document,
                lpo_claim_id: LpoId.lpo_claim_id ?? null,
                customer_id: customerId,
                estimate_id: estimateId,
                job_card_id: estimateDetails?.job_card_id,

            });
        }
    }, [LpoId])

    // useEffect(() => {
    //     setEstimateDetails('');
    //     if (savedJobCard && Object.keys(savedJobCard).length > 0) {
    //         setEstimateDetails(savedJobCard);
    //         setCustomerId(estimateDetails?.customer_id);
    //     } else if (estimate && Object.keys(estimate).length > 0) {
    //         setEstimateDetails(estimate);
    //         setCustomerId(estimateDetails?.customer_id);
    //     }
    // }, [savedJobCard, estimate])

    useEffect(() => {
        setEstimateDetails((prevDetails) => {
            if (savedJobCard && Object.keys(savedJobCard).length > 0) {
                setCustomerId(savedJobCard?.customer_id);
                loadSignatureFromBase64(savedJobCard?.vehicle_graph?.vehicle_graph);
                return savedJobCard;
            } else if (estimate && Object.keys(estimate).length > 0) {
                setCustomerId(estimate?.customer_id);
                loadSignatureFromBase64(estimate?.vehicle_graph?.vehicle_graph);
                return estimate;
            } else {
                setCustomerId(null); // or set it to some default value if needed
                return ''; // or some default value for estimateDetails
            }
        });
    }, [savedJobCard, estimate, customerId]);

    useEffect(() => {
        if (savedJobCard && Object.keys(savedJobCard).length > 0 && Object.keys(estimateDetails).length > 0) {
            setJobCardNoShow(savedJobCard?.job_card_id ? savedJobCard?.job_card_id : '')
            setCustomerName(savedJobCard?.customer?.name || '')
            setJobIn({
                date: moment(savedJobCard?.date).format('YYYY-MM-DD'),
                time: savedJobCard?.time ? savedJobCard?.time : moment().format('HH:mm:ss'),
                start_on: moment(savedJobCard?.date).format('YYYY-MM-DD'),
                km_in: savedJobCard?.km_in || savedJobCard?.milage,
                reference: savedJobCard?.reference ?? '',
                delivery_date: moment(savedJobCard?.delivery_date).format('YYYY-MM-DD'),
                spare_wheel: savedJobCard?.spare_wheel,
                note: savedJobCard?.note,
                estimateId: savedJobCard?.estimate_id,
                contractor_id: savedJobCard?.contractor_id ? { id: savedJobCard?.contractor_id, name: savedJobCard?.insurance_company?.name } : null,
            })
            setReference(savedJobCard?.reference ? { id: savedJobCard?.reference, name: savedJobCard?.reference } : '')
            setContractorId(savedJobCard?.contractor_id ? { id: savedJobCard?.contractor_id, name: savedJobCard?.insurance_company?.name } : null)
            setDocument({
                police_report_id: savedJobCard?.police_report_id,
                driving_license_id: savedJobCard?.driving_license_id,
                lpo_claim_id: savedJobCard?.lpo_claim_id
            })
            setReportNo(savedJobCard?.police_report?.report_no)
            setPolice({ police_id: savedJobCard?.police_report?.police_id })
            setSelectedPolice(savedJobCard?.police_report?.police_id ? { id: savedJobCard?.police_report?.police_id, name: savedJobCard?.police_report?.police_station?.name } : savedJobCard?.police_report?.police_id)
            setLocation(savedJobCard?.police_report?.location)
            setDate(moment(savedJobCard?.police_report?.date).format('YYYY-MM-DD'))
            setTime(savedJobCard?.police_report?.time || '')
            setExpiryDate(moment(savedJobCard?.driving_license?.expiry_date).format('YYYY-MM-DD'))
            setLicenseNo(savedJobCard?.driving_license?.license_no)
            setName(savedJobCard?.driving_license?.name)
            setLpoDate(savedJobCard?.lpo_claim?.date)
            setClaimNo(savedJobCard?.lpo_claim?.lpo_no)
            setValue(savedJobCard?.lpo_claim?.lpo_value ?? '')
            setExcess(savedJobCard?.lpo_claim?.excess)
            setRebate(savedJobCard?.lpo_claim?.rebate)
            setPolicyNo(savedJobCard?.lpo_claim?.policy_no)
            setSelectedType(savedJobCard?.lpo_claim?.lpo_type ? { id: savedJobCard?.lpo_claim?.insurance_type?.insurance_type_id, name: savedJobCard?.lpo_claim?.insurance_type?.name } : '')
            setMiscValue(savedJobCard?.lpo_claim?.misc_value)
            setLpoApproved(savedJobCard?.lpo_claim?.lpo_approved)
            setParts(savedJobCard?.lpo_claim?.parts)
            setRepairs(savedJobCard?.lpo_claim?.repairs)
            setComission(savedJobCard?.lpo_claim?.commission)
            setTowing(savedJobCard?.lpo_claim?.towing)
            setVat(savedJobCard?.lpo_claim?.vat ?? '')
            setExcessVat(savedJobCard?.lpo_claim?.excess_vat ?? '')
            setPartsCost(savedJobCard?.lpo_claim?.parts_cost)
            setRepairsCost(savedJobCard?.lpo_claim?.repair_cost)
            setAdjustments(savedJobCard?.lpo_claim?.adjustment)
            setJobOut({
                job_out: savedJobCard?.job_out,
                km_out: savedJobCard?.km_out,
                out_mobile: savedJobCard?.out_mobile != null ? savedJobCard?.out_mobile : savedJobCard?.customer?.phone,
                lump_sum: savedJobCard?.lump_sum,
                discount: savedJobCard?.discount_amount,
                discount_percentage: savedJobCard?.discount_percentage,
                vat_amount: savedJobCard?.vat_amount,
                vat_percentage: savedJobCard?.vat_percentage,
                total_amount: savedJobCard?.total_amount,
                grand_total: savedJobCard?.grand_total,
            })
            if (savedJobCard?.pay_type && savedJobCard?.pay_type == 'Cash') {
                setSelectedPayType({ value: 1, label: 'Cash' })
            } else if (savedJobCard?.pay_type && savedJobCard?.pay_type == 'Cheque') {
                setSelectedPayType({ value: 2, label: 'Cheque' })
            } else if (savedJobCard?.pay_type && savedJobCard?.pay_type == 'Bank Transfer') {
                setSelectedPayType({ value: 2, label: 'Bank Transfer' })
            } else {
                setSelectedPayType('')
            }
            setDetailShow(true)
            setDocumentShow(true)
            setJobOutShow(true)
            setVehicleGraph(savedJobCard?.vehicle_graph?.vehicle_graph)
            setFuelLevel(savedJobCard?.vehicle_graph?.fuel_level)
        } else if (estimate && Object.keys(estimateDetails).length > 0 && Object.keys(estimate).length > 0) {
            setJobCardNoShow(estimateDetails?.job_card_id)
            setCustomerName(estimateDetails?.customer?.name)
            setJobIn({
                date: moment(estimateDetails?.date).format('YYYY-MM-DD'),
                time: estimateDetails?.time ? estimateDetails?.time : moment().format('HH:mm:ss'),
                start_on: moment(estimateDetails?.date).format('YYYY-MM-DD'),
                km_in: estimateDetails?.km_in || estimateDetails?.milage,
                reference: estimateDetails?.reference || '',
                delivery_date: moment(estimateDetails?.delivery_date).format('YYYY-MM-DD'),
                spare_wheel: estimateDetails?.spare_wheel || '',
                note: estimateDetails?.note || '',
                estimateId: estimateDetails?.estimate_id || '',
                contractor_id: estimateDetails?.insurance_company_id ? { id: estimateDetails?.insurance_company_id, name: estimateDetails?.insurance_company?.name } : null,
            })
            setReference(estimateDetails?.reference ? { id: estimateDetails?.reference, name: estimateDetails?.reference } : '')
            setJobOut({
                ...jobOut,
                total_amount: estimateDetails?.total_amount
            })
            setContractorId(estimateDetails?.insurance_company_id ? { id: estimateDetails?.insurance_company_id, name: estimateDetails?.insurance_company?.name } : null)
            setDocument({
                police_report_id: estimateDetails?.police_report_id || '',
                driving_license_id: estimateDetails?.driving_license_id || '',
                lpo_claim_id: estimateDetails?.lpo_claim_id || '',
            })
            setReportNo(estimateDetails?.police_report?.report_no || '')
            setPolice({ police_id: estimateDetails?.police_report?.police_id } || '')
            setSelectedPolice(estimateDetails?.police_report?.police_id ? { id: estimateDetails?.police_report?.police_id, name: estimateDetails?.police_report?.police_station?.name } : '')
            setLocation(estimateDetails?.police_report?.location || '')
            setDate(moment(estimateDetails?.police_report?.date).format('YYYY-MM-DD'))
            setTime(estimateDetails?.police_report?.time || '')
            setExpiryDate(moment(estimateDetails?.driving_license?.expiry_date).format('YYYY-MM-DD'))
            setLicenseNo(estimateDetails?.driving_license?.license_no || '')
            setName(estimateDetails?.driving_license?.name || '')
            setLpoDate(estimateDetails?.lpo_claim?.date || '')
            setClaimNo(estimateDetails?.lpo_claim?.lpo_no || '')
            setValue(estimateDetails?.lpo_claim?.lpo_value ?? '')
            setExcess(estimateDetails?.lpo_claim?.excess || '')
            setRebate(estimateDetails?.lpo_claim?.rebate || '')
            setPolicyNo(estimateDetails?.lpo_claim?.policy_no || '')
            setSelectedType(estimateDetails?.lpo_claim?.lpo_type ? { id: estimateDetails?.lpo_claim?.insurance_type?.insurance_type_id, name: estimateDetails?.lpo_claim?.insurance_type?.name } : '')
            setMiscValue(estimateDetails?.lpo_claim?.misc_value || '')
            setLpoApproved(estimateDetails?.lpo_claim?.lpo_approved || '')
            setParts(estimateDetails?.lpo_claim?.parts || '')
            setRepairs(estimateDetails?.lpo_claim?.repairs || '')
            setComission(estimateDetails?.lpo_claim?.commission || '')
            setTowing(estimateDetails?.lpo_claim?.towing || '')
            setVat(estimateDetails?.lpo_claim?.vat ?? '')
            setExcessVat(estimateDetails?.lpo_claim?.excess_vat ?? '')
            setPartsCost(estimateDetails?.lpo_claim?.parts_cost || '')
            setRepairsCost(estimateDetails?.lpo_claim?.repair_cost || '')
            setAdjustments(estimateDetails?.lpo_claim?.adjustment || '')
            setJobOut({
                job_out: estimateDetails?.job_out,
                km_out: estimateDetails?.km_out,
                out_mobile: estimateDetails?.out_mobile != null ? estimateDetails?.out_mobile : estimateDetails?.customer?.phone,
                discount: estimateDetails?.discount_amount || '',
                discount_percentage: estimateDetails?.discount_percentage || '',
                vat_amount: estimateDetails?.vat_amount || '',
                vat_percentage: estimateDetails?.vat_percentage || '',
                total_amount: estimateDetails?.total_amount || '',
                grand_total: estimateDetails?.grand_total || '',
                lump_sum: estimateDetails?.lump_sum,
            })
            if (estimateDetails?.pay_type && estimateDetails?.pay_type == 'Cash') {
                setSelectedPayType({ value: 1, label: 'Cash' } || '')
            } else if (estimateDetails?.pay_type && estimateDetails?.pay_type == 'Cheque') {
                setSelectedPayType({ value: 2, label: 'Cheque' } || '')
            } else if (estimateDetails?.pay_type && estimateDetails?.pay_type == 'Bank Transfer') {
                setSelectedPayType({ value: 2, label: 'Bank Transfer' } || '')
            } else {
                setSelectedPayType('')
            }
            setDetailShow(false)
            setDocumentShow(false)
            setJobOutShow(false)
            setVehicleGraph(estimateDetails?.vehicle_graph?.vehicle_graph)
            setFuelLevel(estimateDetails?.vehicle_graph?.fuel_level)
        }
    }, [customerId, savedJobCard, estimate])
    console.log(savedJobCard?.job_out)
    console.log(estimateDetails?.job_out)
    console.log(jobOut)
    useEffect(() => {
        if (JobId) {
            setJobCardNoShow(JobId);
        }
    }, [JobId])

    const handleChangeContractor = (event) => {
        setContractorId({
            id: event.insurance_company_id,
            name: event.name
        })
        setJobIn({
            ...jobIn,
            contractor_id: event?.insurance_company_id,
        });
    };

    const handleChange = (event) => {
        setJobIn({
            ...jobIn,
            job_card_no: jobCardNoShow,
            contractor_id: contractorId?.insurance_company_id,
            estimateId: estimateId,
            [event.target.name]: event.target.value,
        });
    };
    const [reference, setReference] = useState('');

    const handleChangeReference = (event) => {
        setReference({
            id: event.id,
            name: event.name
        })
        setJobIn({
            ...jobIn,
            reference: event.name,
        })
    };

    const handleChangeSpareWheel = (event) => {
        setJobIn({
            ...jobIn,
            spare_wheel: event.target.checked
        })
    };
    const handleChangeLumSum = (event) => {
        setJobOut({
            ...jobOut,
            lump_sum: event.target.checked
        })
    };
    const handleChangeJobOutButton = (event) => {
        setJobOut({
            ...jobOut,
            job_out: event.target.checked
        })
    };
    const handleChangeJobOut = (event) => {
        setJobOut({
            ...jobOut,
            estimate_id: estimateId,
            [event.target.name]: event.target.value,
        });
        // 'formData', jobIn);
    };

    const handleChangePolice = (event) => {
        // 'event', event)
        setPolice({
            police_id: event.police_station_id,
            name: event.name,
        });
        setSelectedPolice({
            police_id: event.police_station_id,
            name: event.name,
        });
    };

    const saveJobIn = async () => {
        if (jobIn.km_in == null) {
            Toast.fire({
                icon: 'error',
                title: 'KM In is Required!'
            })
        } else {
            // 'jobIn', jobIn);
            let data = {
                jobIn: jobIn,
                user_id: user_id,
                vehicle_graph: vehicleGraph,
                fuel_level: fuelLevel,
                // document: document,
                // details: details
            }

            let formData1 = new FormData();
            formData1.append('data', JSON.stringify(data));
            for (var key in files) {
                formData1.append('images[]', files[key])
            }
            await dispatch(saveJobCard(formData1));
            dispatch(getJobCardByEstimateId(estimateId));
            setDocumentShow(true);
            // if (estimateId) {
            //     dispatch(getEstimateById(estimateId));
            // }
        }
    }
    // jobCardNo)
    const saveDocument = async () => {
        let data = {
            // jobIn: jobIn
            document: document,
            user_id: user_id,
            // details: details
        }
        let formData1 = new FormData();
        formData1.append('data', JSON.stringify(data));
        await dispatch(saveJobCard(formData1));
        setDetailShow(true);
    }

    const generatePurchaseOrder = () => {
        let data = {
            jobId: estimateDetails?.job_card_id,
            products: purchaseOrders,
            product_id: productIds,
            user_id: user_id,
            vendor: vendor.bo_supplier_id
        }
        dispatch(generatePurchaseOrders(data));
        dispatch(getJobCardByEstimateId(estimateId));
        setJobOutShow(true)
    }

    const saveDetail = async () => {
        let data = {
            // jobIn: jobIn,
            details: estimateDetails,
            user_id: user_id,
        }
        let formData1 = new FormData();
        formData1.append('data', JSON.stringify(data));
        await dispatch(saveJobCard(formData1));
        // dispatch(getJobCardByEstimateId(estimateId));
        setJobOutShow(true)
    }

    const jobCard = useSelector(state => state?.jobCard?.jobCard);
    // 'jobOUt', jobCard);
    const saveJobOut = async () => {
        let data = {
            // jobIn: jobIn
            jobOut: jobOut,
            imageId: removeImageJobOut,
            estimate_id: estimateId,
            job_card_details: estimateDetails?.job_card_details,
            user_id: user_id,
        }
        let formData1 = new FormData();
        formData1.append('data', JSON.stringify(data));
        for (var key in jobOutFiles) {
            formData1.append('images[]', jobOutFiles[key])
        }
        await dispatch(saveJobCard(formData1));
    }

    const savePerforma = async () => {
        if (jobOut.km_out == null) {
            Toast.fire({
                icon: 'error',
                title: 'KM Out is Required!'
            })
        } else if (!jobOut.out_mobile) {
            Toast.fire({
                icon: 'error',
                title: 'Out Mobile is Required!'
            })
        }
        else {
            let data = {
                jobOut: jobOut,
                imageId: removeImageJobOut,
                estimate_id: estimateId,
                job_card_details: estimateDetails?.job_card_details,
                user_id: user_id,
            }
            let formData1 = new FormData();
            formData1.append('data', JSON.stringify(data));
            for (var key in jobOutFiles) {
                formData1.append('images[]', jobOutFiles[key])
            }
            dispatch(saveJobCard(formData1));
            // 'job out', estimateId);
            await dispatch(savePerformaInvoice(data, navigate));
            // await navigate('/jobCard')
        }
    }

    const deleteItemEstimate = (e, item) => {
        const productId = item.product_id;
        const items = [...estimateDetails.detail_show]; // Create a new array copy
        const indexToRemove = items.findIndex(existingItem => existingItem.product_id === productId);

        if (indexToRemove !== -1) {
            items.splice(indexToRemove, 1);

            let estimate = estimateDetails;
            estimate.detail_show = items;
            setEstimateDetails({ ...estimate });
        }

        // Handle other logic if needed
        // if (items.length > 0) {
        // } else {
        // }
    };

    const deleteItemJobCard = (e, item, index) => {
        // 'item', item);
        let items = estimateDetails.job_card_details;
        items.splice(items.indexOf(item), 1);
        // items.slice(0, index);
        let estimate = estimateDetails;
        estimate.job_card_details = items;
        // 
        setEstimateDetails({ ...estimate });
        // if (items.length > 0) {
        // } else {
        // }
    }

    const onClickItem = (selectedItem) => {
        let selectedItemNew = {
            product_name: selectedItem.name,
            product_type: selectedItem.product_type,
            product_category: selectedItem.product_category.name,
            quantity: 1,
            price_sold: selectedItem.sale_price,
            sale_price: selectedItem.sale_price,
            total_amount: selectedItem.sale_price,
            bo_product_id: selectedItem.bo_product_id,
            product_id: selectedItem.product_id
        }
        var existingItem = '';
        if (estimateDetails.detail_show) {
            existingItem = estimateDetails.detail_show.find(item => item.product_id === selectedItemNew.product_id);
        }
        if (estimateDetails.job_card_details) {
            existingItem = estimateDetails.job_card_details.find(item => item.product_id === selectedItemNew.product_id);
        }

        if (existingItem) {
            Toast.fire({
                icon: 'error',
                title: 'Item Already Exists!'
            })
        } else {
            // selectedItem.quantity = 1;
            let found = false;
            let foundIndex = null;
            // 'selectedItem', selectedItem)
            let estimate = estimateDetails;
            if (estimate.detail_show && estimate.detail_show !== null) {
                estimate.detail_show = [...estimateDetails.detail_show, selectedItemNew];
            } else {
                estimate.detail_show = [selectedItemNew];
            }
            // 'estimate', estimateDetails.detail);
            setEstimateDetails({ ...estimate });
        }
    }

    const moveToOccured = (items, index) => {
        let estimate = estimateDetails;

        if ((items || estimate.job_card_details).every(item => item.product_id !== 3809 && item.product_id !== 6839)) {
            const combinedItems = [...(items || []), ...(estimate.job_card_details || [])];

            // Sum the sale_price from both arrays
            const totalSalePrice = combinedItems.reduce((total, item) => {
                return total + (parseFloat(item.sale_price) || 0);
            }, 0);
            const totalEstimatedAmount = estimateDetails?.estimate?.lump_sum_amount ?? estimateDetails?.estimate?.amount ?? 0;
            const percentageCost = parseFloat(estimateDetails?.estimate?.cost_percentage);
            const twentyPercentOfTotalEstimate = totalEstimatedAmount * percentageCost / 100;

            if (twentyPercentOfTotalEstimate < totalSalePrice) {
                Toast.fire({
                    icon: 'error',
                    title: 'Cost is exceeding than defined Percentage!'
                })
                return;
            }
        }

        // Assign vendor to the product details
        const updatedItems = items.map(item => {
            // Check if product_category is 'Consumable'
            if (item.product_category === 'Consumable') {
                return { ...item, vendor: vendor.bo_supplier_id, vendor_name: vendor.name };
            } else {
                return { ...item }; // If not 'Consumable', keep the item unchanged
            }
        });

        if (!Array.isArray(estimate.job_card_details)) {
            // If not an array, initialize it as an empty array
            estimate.job_card_details = [];
        }
        const product9 = estimate.job_card_details.find(item => item.product_id === 3809);
        const product8 = estimate.job_card_details.find(item => item.product_id === 6839);

        let amount;
        if (product8) {
            amount = value;
        }
        // Update quantity for existing items or add new items
        updatedItems.forEach(updatedItem => {
            const existingItemIndex = estimate.job_card_details.findIndex(existingItem =>
                existingItem.product_id === updatedItem.product_id &&
                existingItem.vendor === updatedItem.vendor
            );
            if (existingItemIndex !== -1) {
                if (updatedItem.product_id === 3809) {
                    // Update the price_sold and total_amount without modifying the quantity
                    estimate.job_card_details[existingItemIndex].price_sold = parseFloat(updatedItem.price_sold);
                    estimate.job_card_details[existingItemIndex].total_amount = parseFloat(updatedItem.total_amount);
                } else if (updatedItem.product_id === 6839) {
                    amount = parseFloat(updatedItem.total_amount);
                    estimate.job_card_details[existingItemIndex].price_sold = parseFloat(updatedItem.price_sold);
                    estimate.job_card_details[existingItemIndex].total_amount = parseFloat(updatedItem.total_amount);
                } else {
                    // For other product_ids, update the quantity
                    estimate.job_card_details[existingItemIndex].quantity += parseInt(updatedItem.quantity);
                    estimate.job_card_details[existingItemIndex].price_sold = parseFloat(updatedItem.price_sold);
                    estimate.job_card_details[existingItemIndex].total_amount = Number(
                        parseFloat(estimate.job_card_details[existingItemIndex].quantity) *
                        parseFloat(estimate.job_card_details[existingItemIndex].price_sold)
                    ).toFixed(2); // Keep two decimal precision
                }
            } else {
                // Add new item to the job_card_details array
                estimate.job_card_details.push(updatedItem);
            }
        });

        if (product8 && product9) {
            // Adjust product8's total_amount and price_sold based on product9
            product8.total_amount = amount - parseFloat(product9.total_amount);
            product8.price_sold = amount - parseFloat(product9.price_sold);
        }

        const updatedPurchaseOrders = updatedItems.reduce((acc, item) => {
            const vendorId = item.vendor;

            // Add a condition to check if vendorId is defined before pushing
            if (vendorId !== undefined) {
                if (!acc[vendorId]) {
                    acc[vendorId] = [];
                }
                acc[vendorId].push(item);
            }

            return acc;
        }, {});

        // Merge existing purchase_orders with updatedPurchaseOrders
        estimate.purchase_orders = { ...estimate.purchase_orders, ...updatedPurchaseOrders };

        setEstimateDetails({ ...estimate });

        // Clear out the items in the purchase orders
        items.forEach(item => {
            deleteItemEstimate(null, item);
        });
        setPurchaseOrders('');
    };


    const moveToEstimated = (e, item, index) => {
        let estimate = estimateDetails;
        item.total_amount = Number(parseInt(item.quantity) * (item.price_sold || item.sale_price)).toFixed(0);
        estimate.detail_show = [...estimateDetails.detail_show, item];
        setEstimateDetails({ ...estimate });
        deleteItemJobCard(null, item, index);
        // 
    }

    const minusQuantityEstimated = async (index) => {
        let investigation = estimateDetails;
        let quantity = parseInt(investigation.detail_show[index].quantity) - 1;
        // investigation)
        if (quantity > 0) {
            investigation.detail_show[index].quantity = (parseInt(investigation.detail_show[index].quantity) - 1).toString();
            if (investigation.detail_show[index].price_sold) {
                investigation.detail_show[index].total_amount = Number(parseInt(quantity) * investigation.detail_show[index].price_sold).toFixed(0);
            } else {
                investigation.detail_show[index].total_amount = Number(parseInt(quantity) * investigation.detail_show[index].sale_price).toFixed(0);
            }
            setEstimateDetails({ ...investigation });
        }
    }

    const addQuantityEstimated = async (index) => {
        let investigation = estimateDetails;
        let quantity = parseInt(investigation.detail_show[index].quantity) + 1;
        investigation.detail_show[index].quantity = quantity.toString();
        if (investigation.detail_show[index].price_sold) {
            investigation.detail_show[index].total_amount = Number(parseInt(quantity) * investigation.detail_show[index].price_sold).toFixed(0);
        } else {
            investigation.detail_show[index].total_amount = Number(parseInt(quantity) * investigation.detail_show[index].sale_price).toFixed(0);
        }
        setEstimateDetails({ ...investigation });
    }

    const minusQuantityOccured = async (index) => {
        let investigation = estimateDetails;
        let quantity = parseInt(investigation.job_card_details[index].quantity) - 1;
        // investigation)
        if (quantity > 0) {
            investigation.job_card_details[index].quantity = (parseInt(investigation.job_card_details[index].quantity) - 1).toString();
            if (investigation.job_card_details[index].price_sold) {
                investigation.job_card_details[index].total_amount = Number(parseInt(quantity) * investigation.job_card_details[index].price_sold).toFixed(0);
            } else {
                investigation.job_card_details[index].total_amount = Number(parseInt(quantity) * investigation.job_card_details[index].sale_price).toFixed(0);
            }
            setEstimateDetails({ ...investigation });
        }
    }

    const addQuantityOccured = async (index) => {
        let investigation = estimateDetails;
        let quantity = parseInt(investigation.job_card_details[index].quantity) + 1;
        investigation.job_card_details[index].quantity = quantity.toString();
        if (investigation.job_card_details[index].price_sold) {
            investigation.job_card_details[index].total_amount = Number(parseInt(quantity) * investigation.job_card_details[index].price_sold).toFixed(0);
        } else {
            investigation.job_card_details[index].total_amount = Number(parseInt(quantity) * investigation.job_card_details[index].sale_price).toFixed(0);
        }
        // investigation.job_card_details[index].total_amount = Number(parseInt(quantity) * investigation.job_card_details[index].sale_price).toFixed(0);
        setEstimateDetails({ ...investigation });
    }


    const [reportNo, setReportNo] = useState('');
    const [police, setPolice] = useState('');
    const [location, setLocation] = useState('');
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [expiryDate, setExpiryDate] = useState('');
    const [licenseNo, setLicenseNo] = useState('');
    const [name, setName] = useState('');

    const LicenseSave = () => {
        if (!expiryDate) {
            Toast.fire({
                icon: 'error',
                title: 'Expiry Date is Required!'
            })
        } else if (!licenseNo) {
            Toast.fire({
                icon: 'error',
                title: 'License No. is Required!'
            })
        } else if (!name) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else {
            let data = {
                expiry_date: expiryDate,
                license_no: licenseNo,
                name: name,
                imageId: removeImageDrivingLicense
            }
            let formData1 = new FormData();
            formData1.append('data', JSON.stringify(data));
            for (var key in drivingLicenseFiles) {
                formData1.append('images[]', drivingLicenseFiles[key])
            }
            dispatch(saveDrivingLicense(formData1));
        }
    }

    useEffect(() => {
        dispatch(getAllPoliceStation('', 9999, { status: 1 }));
    }, []);

    const policeStations = useSelector(state => state?.police?.allPolice?.data);

    const policeReportsave = () => {
        if (!reportNo) {
            Toast.fire({
                icon: 'error',
                title: 'Report Number is Required!'
            })
        } else if (!police.police_id) {
            Toast.fire({
                icon: 'error',
                title: 'Police is Required!'
            })
        } else if (!location) {
            Toast.fire({
                icon: 'error',
                title: 'Location is Required!'
            })
        } else if (!date) {
            Toast.fire({
                icon: 'error',
                title: 'Date is Required!'
            })
        } else if (!time) {
            Toast.fire({
                icon: 'error',
                title: 'Time is Required!'
            })
        } else {
            let data = {
                report_no: reportNo,
                police_id: police.police_id,
                location: location,
                date: date,
                time: time,
                imageId: removeImagePolice,
            }
            let formData1 = new FormData();
            formData1.append('data', JSON.stringify(data));
            for (var key in policeReportFiles) {
                formData1.append('images[]', policeReportFiles[key])
            }
            dispatch(savePoliceReport(formData1));
        }
    }
    const [claimNo, setClaimNo] = useState('');
    const [lpoDate, setLpoDate] = useState('');
    const [value, setValue] = useState();
    const [excess, setExcess] = useState('');
    const [rebate, setRebate] = useState('');
    const [policyNo, setPolicyNo] = useState('');
    const [type, setType] = useState('');
    const [miscValue, setMiscValue] = useState('');
    const [parts, setParts] = useState('');
    const [repairs, setRepairs] = useState('');
    const [comission, setComission] = useState('');
    const [towing, setTowing] = useState('');
    const [vat, setVat] = useState('');
    const [excessVat, setExcessVat] = useState('');
    const [partsCost, setPartsCost] = useState('');
    const [repairsCost, setRepairsCost] = useState('');
    const [adjustments, setAdjustments] = useState('');
    const [lpoApproved, setLpoApproved] = useState('');

    const handleChangeValue = async (e) => {
        setValue(e.target.value)
        let excessAmt = excess || 0;
        const amount = e.target.value - excessAmt;
        const Vat = amount * 5 / 100;
        setVat(Vat)

        let product = {
            price_sold: e.target.value,
            product_category: "Service",
            product_id: 6839,
            bo_product_id: '3011709000003211675',
            product_name: "LUMP SUM",
            product_type: "service",
            quantity: 1,
            sale_price: 0,
            total_amount: e.target.value
        };

        // Initialize an array to store product objects
        let items = [];

        // Add the product object to the array
        items.push(product);
        await moveToOccured(items);
    }

    const handleChangeLpoCalculation = (e) => {
        let amount = e.target.value;

        const calculatedAmount = value - amount;

        const Vat = amount * 5 / 100;
        const calculatedVat = calculatedAmount * 5 / 100;

        setVat(calculatedVat)
        setExcess(amount)
        setExcessVat(Vat)

        let product = {
            price_sold: e.target.value,
            product_category: "Service",
            product_id: 3809,
            bo_product_id: '3011709000003207886',
            product_name: "EXCESS",
            product_type: "service",
            quantity: 1,
            sale_price: 0,
            total_amount: e.target.value
        };

        // Initialize an array to store product objects
        let items = [];

        // Add the product object to the array
        items.push(product);
        moveToOccured(items);
    }

    const save = () => {

        let data = {
            lpo_no: claimNo,
            lpo_value: value,
            // lpo_approved: lpoApproved,
            excess: excess,
            rebate: rebate,
            date: lpoDate,
            policy_no: policyNo,
            misc_value: miscValue,
            lpo_type: type,
            parts: parts,
            repairs: repairs,
            commission: comission,
            towing: towing,
            vat: vat,
            excess_vat: excessVat,
            parts_cost: partsCost,
            repair_cost: repairsCost,
            adjustment: adjustments,
            job_card_id: estimateDetails?.job_card_id,
        }
        dispatch(saveLpo(data));

    }
    // estimateDetails)

    const [section, setSection] = useState('');
    const [files, setFiles] = useState([]);
    const [policeReportFiles, setPoliceReportFiles] = useState([]);
    const [removeImagePolice, setRemoveImagePolice] = useState([]);
    const [drivingLicenseFiles, setDrivingLicenseFiles] = useState([]);
    const [removeImageDrivingLicense, setRemoveImageDrivingLicense] = useState([]);
    const [jobOutFiles, setJobOutFiles] = useState([]);
    const [removeImageJobOut, setRemoveImageJobOut] = useState([]);

    const thumbsContainer = {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: 16
    };

    const thumb = {
        display: 'inline-flex',
        borderRadius: 2,
        border: '1px solid #eaeaea',
        marginBottom: 8,
        marginRight: 15,
        width: 100,
        height: 100,
        padding: 4,
        boxSizing: 'border-box'
    };

    const thumbInner = {
        display: 'block',
        minWidth: 92,
        overflow: 'hidden'
    };
    const thumbEmbed = {
        display: 'inline-flex',
        borderRadius: 2,
        border: '1px solid #eaeaea',
        marginBottom: 8,
        marginRight: 15,
        width: 300,
        height: 200,
        padding: 4,
        boxSizing: 'border-box'
    };

    const thumbInnerEmbed = {
        display: 'block',
        minWidth: 270,
        overflow: 'hidden'
    };

    const img = {
        display: 'block',
        width: 'auto',
        height: '100%'
    };
    const embed = {
        display: 'block',
        width: '100%',
        height: '100%'
    };

    const { getRootProps: getRootPropsJobIn, getInputProps: getInputPropsJobIn } = useDropzone({
        maxFiles: 30,
        accept: '.jpeg,.png,.jpg',
        maxSize: 5000000,
        onDropAccepted: acceptedFiles => {
            if (files && files.length == 1) {
                setFiles(files.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    default: (index == 0) ? 1 : 0
                }))));
            } else {
                if (acceptedFiles.length + files.length > 30 || acceptedFiles.length + policeReportFiles.length > 30) {
                    Toast.fire({
                        icon: 'error',
                        title: 'Maximum 30 Images Allowed',
                    });
                } else {
                    setFiles(files.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                        preview: URL.createObjectURL(file),
                        default: 0
                    }))));
                }
            }
        },
        onDropRejected: rejectedFiles => {
            if (rejectedFiles.length > 0) {
                let error = 'There was an error';
                if (rejectedFiles[0].errors[0].code == 'file-invalid-type') {
                    error = 'File Format Not Supported';
                } else if (rejectedFiles[0].errors[0].code == 'file-too-large') {
                    error = 'Image Size greater than 5mb'
                } else if (rejectedFiles[0].errors[0].code == 'too-many-files') {
                    error = 'Maximum 30 Images Allowed';
                }
                // setDropzoneError(rejectedFiles[0].errors[0].message);
                Toast.fire({
                    icon: 'error',
                    title: error,
                });
            }
        }
    });
    const { getRootProps: getRootPropsPoliceReport, getInputProps: getInputPropsPoliceReport } = useDropzone({
        maxFiles: 30,
        accept: '.jpeg,.png,.jpg,.pdf',
        maxSize: 5000000,
        onDropAccepted: acceptedFiles => {
            if (policeReportFiles && policeReportFiles.length == 1) {
                setPoliceReportFiles(policeReportFiles.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    default: (index == 0) ? 1 : 0
                }))));
            } else {
                if (acceptedFiles.length + files.length > 30 || acceptedFiles.length + policeReportFiles.length > 30) {
                    Toast.fire({
                        icon: 'error',
                        title: 'Maximum 30 Images Allowed',
                    });
                } else {
                    setPoliceReportFiles(policeReportFiles.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                        preview: URL.createObjectURL(file),
                        default: 0
                    }))));
                }
            }
        },
        onDropRejected: rejectedFiles => {
            if (rejectedFiles.length > 0) {
                let error = 'There was an error';
                if (rejectedFiles[0].errors[0].code == 'file-invalid-type') {
                    error = 'File Format Not Supported';
                } else if (rejectedFiles[0].errors[0].code == 'file-too-large') {
                    error = 'Image Size greater than 5mb'
                } else if (rejectedFiles[0].errors[0].code == 'too-many-files') {
                    error = 'Maximum 30 Images Allowed';
                }
                // setDropzoneError(rejectedFiles[0].errors[0].message);
                Toast.fire({
                    icon: 'error',
                    title: error,
                });
            }
        }
    });
    const { getRootProps: getRootPropsDrivingLicense, getInputProps: getInputPropsDrivingLicense } = useDropzone({
        maxFiles: 30,
        accept: '.jpeg,.png,.jpg',
        maxSize: 5000000,
        onDropAccepted: acceptedFiles => {
            if (drivingLicenseFiles && drivingLicenseFiles.length == 1) {
                setDrivingLicenseFiles(drivingLicenseFiles.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    default: (index == 0) ? 1 : 0
                }))));
            } else {
                if (acceptedFiles.length + files.length > 30 || acceptedFiles.length + drivingLicenseFiles.length > 30) {
                    Toast.fire({
                        icon: 'error',
                        title: 'Maximum 30 Images Allowed',
                    });
                } else {
                    setDrivingLicenseFiles(drivingLicenseFiles.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                        preview: URL.createObjectURL(file),
                        default: 0
                    }))));
                }
            }
        },
        onDropRejected: rejectedFiles => {
            if (rejectedFiles.length > 0) {
                let error = 'There was an error';
                if (rejectedFiles[0].errors[0].code == 'file-invalid-type') {
                    error = 'File Format Not Supported';
                } else if (rejectedFiles[0].errors[0].code == 'file-too-large') {
                    error = 'Image Size greater than 5mb'
                } else if (rejectedFiles[0].errors[0].code == 'too-many-files') {
                    error = 'Maximum 30 Images Allowed';
                }
                // setDropzoneError(rejectedFiles[0].errors[0].message);
                Toast.fire({
                    icon: 'error',
                    title: error,
                });
            }
        }
    });
    const { getRootProps: getRootPropsJobOut, getInputProps: getInputPropsJobOut } = useDropzone({
        maxFiles: 30,
        accept: '.jpeg,.png,.jpg',
        maxSize: 5000000,
        onDropAccepted: acceptedFiles => {
            if (jobOutFiles && jobOutFiles.length == 1) {
                setJobOutFiles(jobOutFiles.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    default: (index == 0) ? 1 : 0
                }))));
            } else {
                if (acceptedFiles.length + files.length > 30 || acceptedFiles.length + jobOutFiles.length > 30) {
                    Toast.fire({
                        icon: 'error',
                        title: 'Maximum 30 Images Allowed',
                    });
                } else {
                    setJobOutFiles(jobOutFiles.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                        preview: URL.createObjectURL(file),
                        default: 0
                    }))));
                }
            }
        },
        onDropRejected: rejectedFiles => {
            if (rejectedFiles.length > 0) {
                let error = 'There was an error';
                if (rejectedFiles[0].errors[0].code == 'file-invalid-type') {
                    error = 'File Format Not Supported';
                } else if (rejectedFiles[0].errors[0].code == 'file-too-large') {
                    error = 'Image Size greater than 5mb'
                } else if (rejectedFiles[0].errors[0].code == 'too-many-files') {
                    error = 'Maximum 30 Images Allowed';
                }
                // setDropzoneError(rejectedFiles[0].errors[0].message);
                Toast.fire({
                    icon: 'error',
                    title: error,
                });
            }
        }
    });
    const removeImage = (file, index, type) => {
        if (type == 'jobIn') {
            const updatedFiles = [...files];

            if (index === 0 && file.default === 1) {
                updatedFiles[1].default = 1;
            } else if (index !== 0 && file.default === 1) {
                updatedFiles[0].default = 1;
            }
            let imageIds = [];
            if (updatedFiles[index].id) {

                imageIds = [updatedFiles[index].id];

                setJobIn({
                    ...jobIn,
                    imageId: imageIds
                });

            }
            updatedFiles.splice(index, 1);

            setFiles(updatedFiles);
        } else if (type == 'policeReport') {
            const updatedFiles = [...policeReportFiles];

            if (index === 0 && file.default === 1) {
                updatedFiles[1].default = 1;
            } else if (index !== 0 && file.default === 1) {
                updatedFiles[0].default = 1;
            }
            let imageIds = [];

            if (updatedFiles[index].id) {

                imageIds = updatedFiles[index].id;
                setRemoveImagePolice([
                    ...removeImagePolice,
                    imageIds
                ]);

            }

            updatedFiles.splice(index, 1);

            setPoliceReportFiles(updatedFiles);
        } else if (type == 'drivingLicense') {
            const updatedFiles = [...drivingLicenseFiles];

            if (index === 0 && file.default === 1) {
                updatedFiles[1].default = 1;
            } else if (index !== 0 && file.default === 1) {
                updatedFiles[0].default = 1;
            }
            let imageIds = [];

            if (updatedFiles[index].id) {

                imageIds = updatedFiles[index].id;
                setRemoveImageDrivingLicense([
                    ...removeImageDrivingLicense,
                    imageIds
                ]);

            }

            updatedFiles.splice(index, 1);

            setDrivingLicenseFiles(updatedFiles);
        } else if (type == 'jobOut') {
            const updatedFiles = [...jobOutFiles];
            if (index === 0 && file.default === 1) {
                updatedFiles[1].default = 1;
            } else if (index !== 0 && file.default === 1) {
                updatedFiles[0].default = 1;
            }
            let imageIds = [];

            if (updatedFiles[index].id) {

                imageIds = updatedFiles[index].id;
                setRemoveImageJobOut([
                    ...removeImageJobOut,
                    imageIds
                ]);

            }

            updatedFiles.splice(index, 1);

            setJobOutFiles(updatedFiles);
        }
    }


    const [dropzoneTitle, setDropZoneTitle] = useState("Please Upload Photos");

    const thumbs = files.length > 0 && files.map((file, index) => {
        return (
            <React.Fragment key={index + 1}>
                <SwiperSlide>
                    <div>
                        <div style={thumb} className={`${file.default == 1 ? "default-image" : ''}`} key={file.name}>
                            <div style={thumbInner}>
                                <img
                                    src={file.preview}
                                    style={img}
                                />
                            </div>
                        </div>
                        <span class="image-close" onClick={() => removeImage(file, index, 'jobIn')}>&times;</span>
                    </div>
                </SwiperSlide>
            </React.Fragment>
        )
    }
    );
    const policeReportThumbs = policeReportFiles.length > 0 && policeReportFiles.map((file, index) => {
        return (
            <React.Fragment key={index + 1}>
                <SwiperSlide>
                    <div>
                        <div style={thumbEmbed} className={`${file.default === 1 ? 'default-image' : ''}`} key={file.name}>
                            <div style={thumbInnerEmbed}>
                                {file && Object.keys(file).length > 0 && file?.type?.startsWith('image/') ? (
                                    <img
                                        src={file.preview}
                                        alt={file.name}
                                        style={img} // You may want to adjust the styles here
                                    />
                                ) : file && Object.keys(file).length > 0 && file ? (
                                    <embed
                                        src={file.preview}
                                        style={embed}
                                    />
                                ) : (
                                    <p>File type not supported</p>
                                )}
                            </div>
                        </div>
                        <span className="image-close" onClick={() => removeImage(file, index, 'policeReport')}>&times;</span>
                    </div>
                </SwiperSlide>
            </React.Fragment>
        );
    });

    const drivingLicenseThumbs = drivingLicenseFiles.length > 0 && drivingLicenseFiles.map((file, index) => {
        return (
            <React.Fragment key={index + 1}>
                <SwiperSlide>
                    <div>
                        <div style={thumb} className={`${file.default == 1 ? "default-image" : ''}`} key={file.name}>
                            <div style={thumbInner}>
                                <img
                                    src={file.preview}
                                    style={img}
                                />
                            </div>
                        </div>
                        <span class="image-close" onClick={() => removeImage(file, index, 'drivingLicense')}>&times;</span>
                    </div>
                </SwiperSlide>
            </React.Fragment>
        )
    }
    );
    const jobOutThumbs = jobOutFiles.length > 0 && jobOutFiles.map((file, index) => {
        return (
            <React.Fragment key={index + 1}>
                <SwiperSlide>
                    <div>
                        <div style={thumb} className={`${file.default == 1 ? "default-image" : ''}`} key={file.name}>
                            <div style={thumbInner}>
                                <img
                                    src={file.preview}
                                    style={img}
                                />
                            </div>
                        </div>
                        <span class="image-close" onClick={() => removeImage(file, index, 'jobOut')}>&times;</span>
                    </div>
                </SwiperSlide>
            </React.Fragment>
        )
    }
    );

    const handleChangeType = (e) => {
        setType(e.name)
        setSelectedType({
            name: e.name,
            id: e.id
        })
    }

    // Function to calculate discounted amount, discount percentage, VAT amount, and grand total
    const calculateDiscountAndVAT = (totalAmount, discountPercentage, vatPercentage, vatAmount) => {
        const discountPercent = parseFloat(discountPercentage) / 100;
        const vatPercent = parseFloat(vatPercentage) / 100;

        const discountAmount = totalAmount * discountPercent;
        const discountedTotalAmount = totalAmount - discountAmount;

        let calculatedVATAmount = 0;

        if (vatPercentage) {
            calculatedVATAmount = totalAmount * vatPercent;
        } else if (vatAmount) {
            calculatedVATAmount = vatAmount;
        }

        const grandTotal = discountedTotalAmount + calculatedVATAmount;

        return {
            discountAmount: parseFloat(discountAmount.toFixed(2)),
            discountedTotalAmount: parseFloat(discountedTotalAmount.toFixed(2)),
            vatAmount: parseFloat(calculatedVATAmount.toFixed(2)),
            grandTotal: parseFloat(grandTotal.toFixed(2)),
        };
    };



    // Function to handle discount percentage change
    const handleTotalDiscountPercentageChange = (e) => {
        const discountPercentage = parseFloat(e.target.value.replace('%', '')) || 0;

        // Call the calculateDiscountAndVAT function
        const { discountAmount, discountedTotalAmount, vatAmount, grandTotal } = calculateDiscountAndVAT(
            jobOut.total_amount,
            discountPercentage,
            jobOut.vat_percentage || 0
        );

        // Update jobOut state with the new values
        setJobOut({
            ...jobOut,
            discount_percentage: discountPercentage,
            discount: discountAmount,
            vat: vatAmount,
            grand_total: grandTotal.toFixed(2),
        });
    };

    // Function to handle discount amount change
    const handleTotalDiscountAmountChange = (e) => {
        const discountAmount = parseFloat(e.target.value) || 0;

        // Calculate discount percentage
        const discountPercentage = ((discountAmount / estimateDetails.total_amount) * 100).toFixed(2);

        // Call the calculateDiscountAndVAT function
        const { discountedTotalAmount, vatAmount, grandTotal } = calculateDiscountAndVAT(
            jobOut.total_amount,
            discountPercentage,
            jobOut.vat_percentage || 0
        );

        // Update jobOut state with the new values
        setJobOut({
            ...jobOut,
            discount_percentage: discountPercentage,
            discount: discountAmount,
            vat: vatAmount,
            grand_total: grandTotal.toFixed(2),
        });
    };

    useEffect(() => {
        if (estimateDetails && estimateDetails.job_card_details) {
            const updatedDetails = estimateDetails.job_card_details.map((detail) => {
                const vatPercentage = 5; // Fixed vat_percentage
                let vatAmount = 0;
                let totalAmount = 0;

                if (!detail.price_sold) {
                    vatAmount = (detail.sale_price * detail.quantity * vatPercentage) / 100;
                    totalAmount = detail.sale_price * detail.quantity;
                } else {
                    vatAmount = (detail.price_sold * detail.quantity * vatPercentage) / 100;
                    totalAmount = detail.price_sold * detail.quantity;
                }

                return {
                    ...detail,
                    vat_percentage: vatPercentage,
                    vat_amount: parseFloat(vatAmount),
                    total_amount: parseFloat(totalAmount).toFixed(2),
                };
            });

            let sumOftotalAmount = 0;
            updatedDetails.forEach((detail) => {
                sumOftotalAmount += parseFloat(detail.total_amount);
            });

            const totalVatPercentage = 5; // Fixed vat_percentage
            const totalVatAmount = parseFloat(sumOftotalAmount * totalVatPercentage) / 100;
            let grandTotalAmount = parseFloat(sumOftotalAmount + totalVatAmount);
            console.log('jobOut', jobOut)
            setJobOut({
                ...jobOut,
                vat_percentage: totalVatPercentage,
                vat_amount: parseFloat(totalVatAmount).toFixed(2),
                grand_total: parseFloat(grandTotalAmount).toFixed(2),
                total_amount: parseFloat(sumOftotalAmount).toFixed(2),
                job_out: savedJobCard?.job_out,
                km_out: savedJobCard?.km_out,
                out_mobile: savedJobCard?.out_mobile ?? estimateDetails?.customer?.phone,
                lump_sum: savedJobCard?.lump_sum,
            });
        }
    }, [savedJobCard, estimate, customerId]);

    const [searchTerm, setSearchTerm] = useState('');

    const filteredProducts = products && Object.keys(products).length > 0 && products.filter(product =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const [showCost, setShowCost] = useState(true);

    const [purchaseOrders, setPurchaseOrders] = useState([]);
    const [vendor, setVendor] = useState('');
    const [productIds, setProductIds] = useState([]);

    function handleChangePO(event, detail) {

        // if (!detail.sale_price) {
        //     Toast.fire({
        //         icon: 'error',
        //         title: 'Please Enter Cost!',
        //     });
        //     event.target.checked = false;
        //     return;
        // }
        // if (!detail.price_sold) {
        //     Toast.fire({
        //         icon: 'error',
        //         title: 'Please Enter Price!',
        //     });
        //     event.target.checked = false;
        //     return;
        // } else {
        // If the checkbox is checked, add the detail to purchaseOrders
        if (event.target.checked) {
            // console.log(detail)
            setPurchaseOrders((prevPurchaseOrders) => {
                // Create a new array with the existing elements and the new detail
                return [...prevPurchaseOrders, { ...detail }];
            });
        } else {
            // console.log('here')
            // If the checkbox is unchecked, remove the detail from purchaseOrders
            setPurchaseOrders((prevPurchaseOrders) => {
                // Filter out the detail with the matching product_id
                return prevPurchaseOrders.filter(order => order.product_id !== detail.product_id);
            });
        }
        // console.log(purchaseOrders)
        // }
    }

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        if (!purchaseOrders) {
            Toast.fire({
                icon: 'error',
                title: 'Please Select Products!',
            });
            return;
        }
        // console.log(purchaseOrders);
        const totalAmount = purchaseOrders.reduce((sum, order) => {
            const amount = parseFloat(order.total_amount) || 0;
            return sum + amount;
        }, 0);

        if (purchaseOrders) {
            // console.log('if1111111')
            const hasConsuItem = purchaseOrders && purchaseOrders.some(order => order.product_category === 'Consumable');
            if (!purchaseOrders) {
                Toast.fire({
                    icon: 'error',
                    title: 'Please Select Products!',
                });
            } else if (hasConsuItem) {
                setShow(true);
            } else {
                // Directly hit moveToOccured function
                moveToOccured(purchaseOrders);
            }
        }
    }

    const handleMoveButtonClick = () => {

        if (vendor !== null) {
            moveToOccured(purchaseOrders)
        } else {
            Toast.fire({
                icon: 'error',
                title: 'Please Select Vendor!',
            });
        }
        handleClose();
    }

    const [vehicleGraph, setVehicleGraph] = useState('');
    const [fuelLevel, setFuelLevel] = useState('');

    const FuelOptions = [
        { label: 'F', value: 'F' },
        { label: '95%', value: '95%' },
        { label: '90%', value: '90%' },
        { label: '85%', value: '85%' },
        { label: '80%', value: '80%' },
        { label: '75%', value: '75%' },
        { label: '70%', value: '70%' },
        { label: '65%', value: '65%' },
        { label: '60%', value: '60%' },
        { label: '55%', value: '55%' },
        { label: '50%', value: '50%' },
        { label: '45%', value: '45%' },
        { label: '40%', value: '40%' },
        { label: '35%', value: '35%' },
        { label: '30%', value: '30%' },
        { label: '25%', value: '25%' },
        { label: '20%', value: '20%' },
        { label: '15%', value: '15%' },
        { label: '10%', value: '10%' },
        { label: '5%', value: '5%' },
        { label: 'E', value: 'E' },
    ];

    const handleChangFuel = (e) => {
        // e)
        setFuelLevel(e.value);
    };

    const signatureRef = useRef(null);

    const clearCanvas = () => {
        signatureRef.current.clear(); // Clear the canvas
        const base64Data = signatureRef.current.toDataURL();
        setVehicleGraph(base64Data);
    };

    const getVehicleGraph = () => {
        if (signatureRef.current) {
            signatureRef.current.getCanvas().style.width = '370px';
            signatureRef.current.getCanvas().style.height = '250px';
            // Use toDataURL() without trimming to preserve exact positions
            const base64Data = signatureRef.current.toDataURL();
            setVehicleGraph(base64Data);
        } else {
            console.error("SignatureCanvas is not available yet.");
        }
    };

    const loadSignatureFromBase64 = (base64String) => {
        if (signatureRef.current && base64String) {
            // Clear the current canvas before loading the new data
            signatureRef.current.clear();

            // Create an image to load base64 and adjust scaling
            const img = new Image();
            img.src = base64String;
            img.onload = () => {
                if (signatureRef && signatureRef.current) {
                    const canvas = signatureRef.current.getCanvas();
                    const ctx = canvas.getContext('2d');
                    ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas

                    // Ensure the canvas size matches original
                    canvas.width = 370;
                    canvas.height = 250;

                    // Draw the base64 image onto the canvas, adjusting for any offset
                    ctx.drawImage(img, 0, 0, 370, 250);
                }
            };
        }
    };

    return (
        <span>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    {
                        addEditLoading ?
                            <ThreeDots
                                height="80"
                                width="80"
                                radius="9"
                                color="#2d3748"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                wrapperClassName=""
                                visible={addEditLoading}
                            /> :
                            <span>
                                <div className="d-flex justify-content-between align-items-center mt-2">
                                    {
                                        estimateDetails.job_card_id ?
                                            <div>
                                                <h2 className="intro-y px-5 fs-lg fw-medium me-auto">
                                                    Job Id : {estimateDetails?.job_card_id}
                                                </h2>
                                                <h2 className="intro-y px-5 fs-lg fw-medium me-auto">
                                                    Total Estimated Price: {estimateDetails?.estimate?.lump_sum_amount ?? estimateDetails?.estimate?.amount ?? 0}
                                                </h2>
                                            </div>
                                            :
                                            <h2 className="intro-y px-5 fs-lg fw-medium me-auto">
                                                Add Job Card
                                            </h2>
                                    }
                                    <div>
                                        <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#customer-modal" >Edit Customer</button>
                                        <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#vehicle-modal" >Edit Vehicle</button>
                                    </div>
                                </div>
                                <div className="box p-3 mt-3">
                                    <ul className="pos__tabs nav nav-pills rounded-2" role="tablist">
                                        <li id="jobIn-tab" className="nav-item box mx-3 flex-1" role="presentation">
                                            <button className="nav-link w-full pt-2 pb-2.5 active" data-bs-toggle="pill" data-bs-target="#jobIn" type="button" role="tab" aria-controls="jobIn-tab" aria-selected="true">Job In</button>
                                        </li>
                                        {
                                            documentShow && contractorId?.id != 5536 ?
                                                <li id="documents-tab" className="nav-item box mx-3 flex-1" role="presentation">
                                                    <button className="nav-link w-full pt-2 pb-2.5" data-bs-toggle="pill" data-bs-target="#documents" type="button" role="tab" aria-controls="documents-tab" aria-selected="false">Documents</button>
                                                </li>
                                                :
                                                ''
                                        }
                                        {
                                            detailShow &&
                                            <li id="details-tab" className="nav-item box mx-3 flex-1" role="presentation">
                                                <button className="nav-link w-full pt-2 pb-2.5" data-bs-toggle="pill" data-bs-target="#details" type="button" role="tab" aria-controls="details-tab" aria-selected="false">Details</button>
                                            </li>
                                        }
                                        {
                                            jobOutShow &&
                                            <li id="jobOut-tab" className="nav-item box mx-3 flex-1" role="presentation">
                                                <button className="nav-link w-full pt-2 pb-2.5" data-bs-toggle="pill" data-bs-target="#jobOut" type="button" role="tab" aria-controls="jobOut-tab" aria-selected="false">Job Out</button>
                                            </li>
                                        }
                                        {/* <li id="summary-tab" className="nav-item box mx-3 flex-1" role="presentation">
                            <button className="nav-link w-full pt-2 pb-2.5" data-bs-toggle="pill" data-bs-target="#summary" type="button" role="tab" aria-controls="summary-tab" aria-selected="false">Summary</button>
                        </li> */}
                                    </ul>
                                    <div className="tab-content">
                                        <div className="tab-pane fade show active" id="jobIn" role="tabpanel" aria-labelledby="jobIn-tab">
                                            <div className="intro-y">
                                                <div className="px-5 mt-6 py-5">
                                                    <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end">
                                                        {/* <button className="btn btn-outline-secondary w-24">Cancel</button> */}
                                                        <button onClick={saveJobIn} disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button>
                                                    </div>
                                                    <div className="grid columns-12">
                                                        <div className="intro-y g-col-12 g-col-lg-7 g-col-sm-12">
                                                            <div className="grid columns-12">
                                                                {/* <div className="intro-y g-col-12 g-col-sm-2">
                                                    <label for="job_no" className="form-label">Job No.<span className="text-theme-6">*</span> :</label>
                                                    {
                                                        loading ?
                                                            <input id="job_no" value={'Loading ...'} disabled onChange={(e) => setJobCardNo(e.target.value)} name="job_card_no" type="text" className="form-control " placeholder="Enter Job No." />
                                                            :
                                                            <input id="job_no" value={jobCardNoShow} disabled onChange={(e) => setJobCardNo(e.target.value)} name="job_card_no" type="text" className="form-control " placeholder="Enter Job No." />
                                                    }
                                                </div> */}
                                                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-12 d-flex align-items-center">
                                                                    <div class="form-check mt-5"> <input id="checkbox-switch-4" class="form-check-input" type="checkbox" checked={jobIn?.spare_wheel == "1" ? true : false} onChange={handleChangeSpareWheel} /> <label class="form-check-label" for="checkbox-switch-4">Spare Wheel</label> </div>
                                                                </div>
                                                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-12">
                                                                    <label for="date" className="form-label">Date<span className="text-theme-6">*</span> :</label>
                                                                    <div className="input-group mx-auto ">
                                                                        <div id="input-group-email" className="input-group-text "> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-calendar w-4 h-4"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> </div> <input onChange={handleChange} type="date" placeholder="Enter Date" id="date" name="date" value={jobIn?.date} className="datepicker form-control " data-single-mode="true" />
                                                                    </div>
                                                                </div>
                                                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-12">
                                                                    <label for="time" className="form-label">Time<span className="text-theme-6">*</span> :</label>
                                                                    <input id="time" onChange={handleChange} name="time" value={jobIn?.time} type="time" className="form-control " placeholder="Enter Time" />
                                                                </div>
                                                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-12">
                                                                    <label for="start_on" className="form-label">Start On<span className="text-theme-6">*</span> :</label>
                                                                    <div className="input-group mx-auto ">
                                                                        <div id="input-group-email" className="input-group-text "> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-calendar w-4 h-4"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> </div> <input onChange={handleChange} type="date" placeholder="Enter Starting Date" id="start_on" value={jobIn?.start_on} name="start_on" className="datepicker form-control " data-single-mode="true" />
                                                                    </div>
                                                                </div>
                                                                {
                                                                    estimateDetails?.insurance_company == null ?
                                                                        '' :
                                                                        <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-12">
                                                                            <label for="contractor" className="form-label">Contractor :</label>
                                                                            <Select isDisabled={user_permissions.some(item => item.permission_id == 41) ? false : true} name="contractor_id" value={contractorId} onChange={(e) => handleChangeContractor(e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.id}`} options={insuranceCompanies && insuranceCompanies.length > 0 ? insuranceCompanies : []} styles={styleSelect} placeholder="Select Contractor" />
                                                                        </div>
                                                                }
                                                                {/* <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-12">
                                                        <label for="job_type" className="form-label">Job Type :</label>
                                                        <Select styles={styleSelect} value={estimateDetails?.type_id ? {value:estimateDetails?.type_id , label: TypeOptions?.label} : null} onChange={(e) => setTypeId(e.type_id)} options={TypeOptions}/>
                                                    </div> */}
                                                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-12">
                                                                    <label for="km" className="form-label">KM in <span className="text-theme-6">*</span> :</label>
                                                                    <input id="km" name="km_in" onChange={handleChange} value={jobIn?.km_in} type="number" className="form-control" placeholder="Enter Km" />
                                                                </div>
                                                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-12">
                                                                    <label for="reference" className="form-label">Reference :</label>
                                                                    {/* <input id="reference" onChange={handleChange} value={jobIn?.reference} name="reference" type="text" className="form-control" placeholder="Enter Reference" /> */}
                                                                    <Select name="reference" value={reference} onChange={(e) => handleChangeReference(e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.name}`} options={insuranceCompanies && insuranceCompanies.length > 0 ? insuranceCompanies : []} styles={styleSelect} placeholder="Select Reference" />
                                                                </div>
                                                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-12">
                                                                    <label for="delivery_date" className="form-label">Delivery Date :</label>
                                                                    <div className="input-group mx-auto ">
                                                                        <div id="input-group-email" className="input-group-text "> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-calendar w-4 h-4"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> </div> <input onChange={handleChange} value={jobIn?.delivery_date} type="date" placeholder="Enter Delivery Date" id="delivery_date" name="delivery_date" className="datepicker form-control " min={new Date().toISOString().split('T')[0]} data-single-mode="true" />
                                                                    </div>
                                                                </div>
                                                                <div className="intro-y g-col-4 g-col-lg-5 g-col-md-12 g-col-sm-12">
                                                                    <label for="note" className="form-label">Note:</label>
                                                                    <textarea id="note" onChange={handleChange} value={jobIn?.note} name="note" type="text" rows={4} className="form-control" placeholder="Enter Note" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <div className="intro-y g-col-12 g-col-sm-2">

                                            <GaugeContainer>
                                                <GaugeNeedle angle={needleAngle} />
                                                <input type="range" min="0" max="100" value={fuelLevel} onChange={handleFuelLevelChange} />
                                            </GaugeContainer>

                                        </div> */}
                                                        <div className="intro-y g-col-12 g-col-lg-5 g-col-sm-12">
                                                            <label for="image" className="form-label">Image :</label>
                                                            <section className="text-center form-control w-full">
                                                                <aside style={thumbsContainer} className="justify-content-center mb-0">
                                                                    {
                                                                        (files.length == 0) &&
                                                                        <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                                                    }
                                                                </aside>
                                                                <Swiper
                                                                    slidesPerView={4}
                                                                    scrollbar={{
                                                                        hide: true,
                                                                    }}
                                                                    grid={{
                                                                        rows: 1,
                                                                    }}
                                                                    modules={[Grid, Scrollbar]}
                                                                    className="mySwiper h-full"
                                                                >
                                                                    {thumbs}
                                                                </Swiper>
                                                                <div {...getRootPropsJobIn({
                                                                    className: 'dropzone p-3'
                                                                })}>
                                                                    <input {...getInputPropsJobIn()} />
                                                                    <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                                                    <div className="btn btn-primary w-25 mt-5">Upload Photos</div>
                                                                </div>
                                                            </section>
                                                            <div className="d-flex align-items-center justify-content-between mt-3">
                                                                <label for="signature" className="form-label">Vehicle Graph <span className="text-theme-6">*</span> :</label>
                                                                <button className="btn btn-outline-secondary mb-2" onClick={clearCanvas}>Clear</button>
                                                            </div>
                                                            <div className="border border-gray-300 rounded-2 canvas-bg" style={{ width: 370, height: 250 }}>
                                                                <SignatureCanvas
                                                                    penColor='red'
                                                                    onEnd={getVehicleGraph}
                                                                    ref={(ref) => (signatureRef.current = ref)}
                                                                    onKeyPress={clearCanvas}
                                                                    canvasProps={{ width: 370, height: 250, className: 'signatureCanvas' }}
                                                                />
                                                            </div>
                                                            <label for="crud-form-1" className="form-label mt-3">Fuel <span className="text-theme-6">*</span> :</label>
                                                            <Select styles={styleSelect} className="z-50" value={{ label: fuelLevel, value: fuelLevel }} options={FuelOptions} id="repalcedVehicleFuelId" name="replacedVehicleFuelOut" onChange={(e) => handleChangFuel(e)} />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        {
                                            documentShow &&
                                            <div className="tab-pane fade show" id="documents" role="tabpanel" aria-labelledby="documents-tab">
                                                <div className="intro-y ">
                                                    <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end mt-5">
                                                        {/* <button className="btn btn-outline-secondary w-24">Cancel</button> */}
                                                        <button onClick={saveDocument} disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button>
                                                    </div>
                                                    <div className="px-5 pb-5">
                                                        <div className="grid columns-12 gap-4 gap-y-3">
                                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                                <label for="customer_name" className="form-label">Customer Name<span className="text-theme-6">*</span> :</label>
                                                                <input id="customer_name" disabled name="customer_name" value={customerName} type="text" className="form-control" placeholder="Enter Customer Name" />
                                                            </div>
                                                            {/* <div className="intro-y g-col-12 g-col-sm-2 d-flex align-items-end justify-content-center">
                                                    <a className="d-flex align-items-center btn btn-success me-3" href="javascript:;"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-plus w-6 h-6 me-1"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg> Add </a>
                                                    <a className="d-flex align-items-center me-3 btn btn-primary me-3" href=""> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-edit me-1 w-6 h-6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Edit </a>
                                                </div> */}
                                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                                <label for="estimate_no" className="form-label">Estimate No.<span className="text-theme-6">*</span> :</label>
                                                                <input id="estimate_no" name="estimate_no" value={estimateId} disabled type="text" className="form-control" placeholder="Enter Estimate No." />
                                                            </div>
                                                            {/* <div className="intro-y g-col-12 g-col-sm-2 d-flex align-items-end justify-content-center">
                                                <a className="d-flex align-items-center btn btn-success me-3" href="javascript:;"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-plus w-6 h-6 me-1"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg> Add </a>
                                                <a className="d-flex align-items-center btn btn-primary me-3" href="javascript:;" data-bs-toggle="modal" data-bs-target="#vehicle-modal"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-edit me-1 w-6 h-6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>Edit </a>
                                            </div> */}
                                                            <div className="g-col-12 mt-5 me-4 g-col-lg-2 g-col-sm-3">
                                                                <div class="">
                                                                    <ul class="chat__tabs nav nav-pills rounded-2 flex-column"
                                                                        role="tablist">
                                                                        <li id="policeReport-tab"
                                                                            class="nav-item flex-1 m-2"
                                                                            role="presentation">
                                                                            <button
                                                                                class="nav-link w-full my-2 pt-2 active fs-base text-start br-right-radius me-4 pb-2.5"
                                                                                data-bs-toggle="pill"
                                                                                data-bs-target="#policeReport"
                                                                                type="button" role="tab"
                                                                                aria-controls="policeReport-tab"
                                                                                aria-selected="false">Police Report</button>
                                                                        </li>
                                                                        <li id="license-tab"
                                                                            class="nav-item flex-1 m-2"
                                                                            role="presentation">
                                                                            <button
                                                                                class="nav-link w-full my-2 pt-2 fs-base text-start br-right-radius me-4 pb-2.5"
                                                                                data-bs-toggle="pill"
                                                                                data-bs-target="#license"
                                                                                type="button" role="tab"
                                                                                aria-controls="license-tab"
                                                                                aria-selected="false">Driving License</button>
                                                                        </li>
                                                                        <li id="lpo-tab"
                                                                            class="nav-item flex-1 m-2"
                                                                            role="presentation">
                                                                            <button
                                                                                class="nav-link w-full my-2 pt-2 fs-base text-start br-right-radius me-4 pb-2.5"
                                                                                data-bs-toggle="pill"
                                                                                data-bs-target="#lpo"
                                                                                type="button" role="tab"
                                                                                aria-controls="lpo-tab"
                                                                                aria-selected="false">LPO Claim</button>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="g-col-12 mt-5 g-col-lg-10 g-col-sm-9">
                                                                <div class="tab-content">
                                                                    <div class="tab-pane fade show active"
                                                                        id="policeReport" role="tabpanel"
                                                                        aria-labelledby="policeReport-tab">
                                                                        <h2 className="fw-medium fs-base mb-2 me-auto">Police Report</h2>
                                                                        <div className="grid columns-12">
                                                                            <div className="intro-y g-col-12 g-col-lg-3 g-col-sm-6">
                                                                                <label for="report_no" className="form-label">Report No.<span className="text-theme-6">*</span> :</label>
                                                                                <input id="report_no" value={reportNo} onChange={(e) => setReportNo(e.target.value)} name="report_no" type="text" required className="form-control" placeholder="Enter Report No." />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-3 g-col-sm-6">
                                                                                <label for="police" className="form-label">Police<span className="text-theme-6">*</span> :</label>
                                                                                <Select styles={styleSelect} value={selectedPolice} onChange={(e) => handleChangePolice(e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.police_station_id}`} options={policeStations && policeStations.length > 0 ? policeStations : []} />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-3 g-col-sm-6">
                                                                                <label for="date" className="form-label">Date<span className="text-theme-6">*</span> :</label>
                                                                                <input id="date" name="date" value={date} onChange={(e) => setDate(e.target.value)} max={new Date().toISOString().split('T')[0]} type="date" className="form-control" placeholder="Enter Date" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-3 g-col-sm-6">
                                                                                <label for="time" className="form-label">Time<span className="text-theme-6">*</span> :</label>
                                                                                <input id="time" name="time" value={time} onChange={(e) => setTime(e.target.value)} type="time" className="form-control" placeholder="Enter Time" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-sm-12">
                                                                                <label for="location" className="form-label">Location<span className="text-theme-6">*</span> :</label>
                                                                                <input id="location" name="location" value={location} onChange={(e) => setLocation(e.target.value)} type="text" required className="form-control" placeholder="Enter Location" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12">
                                                                                <label for="image" className="form-label">Image:</label>
                                                                                <section className="text-center form-control w-full">
                                                                                    <aside style={thumbsContainer} className="justify-content-center mb-0">
                                                                                        {
                                                                                            (policeReportFiles.length == 0) &&
                                                                                            <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                                                                        }
                                                                                    </aside>
                                                                                    <Swiper
                                                                                        slidesPerView={3}
                                                                                        scrollbar={{
                                                                                            hide: true,
                                                                                        }}
                                                                                        grid={{
                                                                                            rows: 1,
                                                                                        }}
                                                                                        modules={[Grid, Scrollbar]}
                                                                                        className="mySwiper h-full"
                                                                                    >
                                                                                        {policeReportThumbs}
                                                                                    </Swiper>
                                                                                    <div {...getRootPropsPoliceReport({
                                                                                        className: 'dropzone p-3'
                                                                                    })}>
                                                                                        <input {...getInputPropsPoliceReport()} />
                                                                                        <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                                                                        <div className="btn btn-primary w-25 mt-5">Upload Photos</div>
                                                                                    </div>
                                                                                </section>
                                                                            </div>
                                                                        </div>
                                                                        <div className="text-end mt-5">
                                                                            {/* <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-20 me-1">Cancel</button> */}
                                                                            <button onClick={policeReportsave} disabled={loading ? true : false} type="button" className="btn btn-primary w-20">Submit</button>
                                                                        </div>
                                                                    </div>
                                                                    <div class="tab-pane fade"
                                                                        id="license" role="tabpanel"
                                                                        aria-labelledby="license-tab">
                                                                        <h2 className="fw-medium fs-base mb-2 me-auto">Driving License</h2>
                                                                        <div className="grid columns-12">
                                                                            <div className="intro-y g-col-3 g-col-lg-3 g-col-sm-6">
                                                                                <label for="expiry_date" className="form-label">Expiry Date<span className="text-theme-6">*</span> :</label>
                                                                                <div className="input-group mx-auto ">
                                                                                    <div id="input-group-email" className="input-group-text "> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-calendar w-4 h-4"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> </div> <input type="date" value={expiryDate} placeholder="Enter Expiry Date" onChange={(e) => setExpiryDate(e.target.value)} id="expiry_date" name="expiry_date" className="datepicker form-control " data-single-mode="true" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="licence_no" className="form-label"> Licence No.<span className="text-theme-6">*</span> :</label>
                                                                                <input id="licence_no" value={licenseNo} onChange={(e) => setLicenseNo(e.target.value)} name="licence_no" type="text" className="form-control" placeholder="Enter Licence No" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-5 g-col-sm-12">
                                                                                <label for="name" className="form-label">Name<span className="text-theme-6">*</span> :</label>
                                                                                <input id="name" value={name} onChange={(e) => setName(e.target.value)} name="name" type="text" required className="form-control" placeholder="Enter Name" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12">
                                                                                <label for="image" className="form-label">Image:</label>
                                                                                <section className="text-center form-control w-full">
                                                                                    <aside style={thumbsContainer} className="justify-content-center mb-0">
                                                                                        {
                                                                                            (drivingLicenseFiles.length == 0) &&
                                                                                            <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                                                                        }
                                                                                    </aside>
                                                                                    <Swiper
                                                                                        slidesPerView={6}
                                                                                        scrollbar={{
                                                                                            hide: true,
                                                                                        }}
                                                                                        grid={{
                                                                                            rows: 1,
                                                                                        }}
                                                                                        modules={[Grid, Scrollbar]}
                                                                                        className="mySwiper h-full"
                                                                                    >
                                                                                        {drivingLicenseThumbs}
                                                                                    </Swiper>
                                                                                    <div {...getRootPropsDrivingLicense({ className: 'dropzone p-3' })}>
                                                                                        <input {...getInputPropsDrivingLicense()} />
                                                                                        <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                                                                        <div className="btn btn-primary w-25 mt-5">Upload Photos</div>
                                                                                    </div>
                                                                                </section>
                                                                            </div>
                                                                        </div>
                                                                        <div className="text-end mt-5">
                                                                            {/* <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-20 me-1">Cancel</button> */}
                                                                            <button onClick={LicenseSave} type="button" disabled={loading ? true : false} className="btn btn-primary w-20">Submit</button>
                                                                        </div>
                                                                    </div>
                                                                    <div class="tab-pane fade"
                                                                        id="lpo" role="tabpanel"
                                                                        aria-labelledby="lpo-tab">
                                                                        <h2 className="fw-medium fs-base mb-2 me-auto">LPO Claim</h2>
                                                                        <div className="grid columns-12">
                                                                            {/* <div className="intro-y g-col-6">
                                                <label for="lpo_id" className="form-label"> LPO ID :</label>
                                                <input id="lpo_id" name="lpo_id" type="text" required className="form-control" placeholder="Enter LPO ID" />
                                            </div> */}
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="date" className="form-label">Date :</label>
                                                                                <div className="input-group mx-auto ">
                                                                                    <div id="input-group-email" className="input-group-text "> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-calendar w-4 h-4"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> </div> <input type="date" value={lpoDate} placeholder="Enter Date" onChange={(e) => setLpoDate(e.target.value)} id="date" name="lpoDate" className="datepicker form-control " data-single-mode="true" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="claim_no" className="form-label">Claim No. :</label>
                                                                                <input id="claim_no" value={claimNo} onChange={(e) => setClaimNo(e.target.value)} name="claim_no" type="text" required className="form-control" placeholder="Enter Claim No." />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="value" className="form-label"> Value<span className="text-theme-6">*</span> :</label>
                                                                                <input id="value" value={value} onChange={(e) => handleChangeValue(e)} name="value" type="text" className="form-control" placeholder="Enter Value" />
                                                                            </div>
                                                                            {/* <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="lpoApproved" className="form-label">LPO Amount Approved<span className="text-theme-6">*</span> :</label>
                                                                                <input id="lpoApproved" value={lpoApproved} name="lpoApproved" type="text" required className="form-control" onChange={(e) => handleChangeLpoCalculation(e)} placeholder="Enter LPO Amount Approved" />
                                                                            </div> */}
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="excess" className="form-label">Excess :</label>
                                                                                <input id="excess" value={excess} onChange={(e) => handleChangeLpoCalculation(e)} name="excess" type="text" required className="form-control" placeholder="Enter Excess" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="rebate" className="form-label">Rebate (%) :</label>
                                                                                <input id="rebate" name="rebate" value={rebate} onChange={(e) => setRebate(e.target.value)} type="text" required className="form-control" placeholder="Enter Rebate" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="policy_no" className="form-label">Policy No. :</label>
                                                                                <input id="policy_no" value={policyNo} onChange={(e) => setPolicyNo(e.target.value)} name="policy_no" type="text" required className="form-control" placeholder="Enter Policy No." />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="type" className="form-label">Type :</label>
                                                                                <Select styles={styleSelect} value={selectedType} onChange={(e) => handleChangeType(e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.name}`} options={insuranceTypes && insuranceTypes.length > 0 ? insuranceTypes : []} />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="misc_value" className="form-label">Misc Value :</label>
                                                                                <input id="misc_value" value={miscValue} name="misc_value" onChange={(e) => setMiscValue(e.target.value)} type="text" required className="form-control" placeholder="Enter Misc Value" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="parts" className="form-label">Parts :</label>
                                                                                <input id="parts" name="parts" value={parts} onChange={(e) => setParts(e.target.value)} type="text" required className="form-control" placeholder="Enter Parts" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="repairs" className="form-label">Repairs :</label>
                                                                                <input id="repairs" name="repairs" value={repairs} onChange={(e) => setRepairs(e.target.value)} type="text" required className="form-control" placeholder="Enter Repairs" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="comission" className="form-label">Comission :</label>
                                                                                <input id="comission" name="comission" value={comission} onChange={(e) => setComission(e.target.value)} type="text" required className="form-control" placeholder="Enter Comission" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="towing" className="form-label">Towing :</label>
                                                                                <input id="towing" name="towing" type="text" value={towing} onChange={(e) => setTowing(e.target.value)} required className="form-control" placeholder="Enter Towing" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="vat" className="form-label">VAT :</label>
                                                                                <input id="vat" name="vat" disabled value={vat} onChange={(e) => setVat(e.target.value)} type="text" required className="form-control" placeholder="Enter VAT" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="vat" className="form-label">Excess VAT :</label>
                                                                                <input id="vat" name="vat" disabled value={excessVat} onChange={(e) => setExcessVat(e.target.value)} type="text" required className="form-control" placeholder="Enter Excess VAT" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="parts_cost" className="form-label">Parts Cost :</label>
                                                                                <input id="parts_cost" value={partsCost} name="parts_cost" onChange={(e) => setPartsCost(e.target.value)} type="text" required className="form-control" placeholder="Enter Parts Cost" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="repair_cost" className="form-label">Repair Cost :</label>
                                                                                <input id="repair_cost" value={repairsCost} name="repair_cost" type="text" onChange={(e) => setRepairsCost(e.target.value)} required className="form-control" placeholder="Enter Repair Cost" />
                                                                            </div>
                                                                            <div className="intro-y g-col-12 g-col-lg-4 g-col-sm-6">
                                                                                <label for="adjustment" className="form-label">Adjustments :</label>
                                                                                <input id="adjustment" value={adjustments} name="adjustment" type="text" onChange={(e) => setAdjustments(e.target.value)} required className="form-control" placeholder="Enter Adjustments" />
                                                                            </div>
                                                                        </div>
                                                                        <div className="text-end mt-5">
                                                                            {/* <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-20 me-1">Cancel</button> */}
                                                                            <button onClick={save} type="button" disabled={loading ? true : false} className="btn btn-primary w-20">Submit</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {
                                            detailShow &&
                                            <div className="tab-pane fade show" id="details" role="tabpanel" aria-labelledby="details-tab">
                                                <div className="intro-y">
                                                    <div className="px-5 mt-6 pb-5">
                                                        <div className="grid columns-12">
                                                            <div className="g-col-12 g-col-sm-12 d-flex justify-content-between align-items-end">
                                                                <div>
                                                                    <h2 className="intro-y fs-lg fw-medium mb-0 ms-2">
                                                                        Products :
                                                                        <button className="btn btn-primary p-1 ms-1" data-bs-toggle="modal" data-bs-target="#add-product-modal">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-plus w-4 h-4"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                                                        </button>
                                                                    </h2>
                                                                    <h3 className="fs-base fw-medium ms-2">
                                                                        Lpo Value: {value}
                                                                    </h3>
                                                                </div>
                                                                <div>
                                                                    {/* <button data-bs-toggle="modal" data-bs-target="#vendorModal" type="button" className="btn btn-primary me-1 text-nowrap">Generate Purchase Order</button> */}
                                                                    <button onClick={saveDetail} disabled={loading ? true : false} type="button" className="btn btn-primary w-32 me-1">Save</button>
                                                                    <div className="intro-y g-col-12 g-col-sm-4 d-flex align-items-center">
                                                                        <div class="form-check mt-2"> <input id="checkbox-switch-4" class="form-check-input" type="checkbox" checked={showCost} onChange={(e) => setShowCost(e.target.checked)} /> <label class="form-check-label" for="checkbox-switch-4">Show Cost</label> </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="g-col-12 g-col-sm-12">
                                                                <div className="pos intro-y grid columns-12 gap-5">
                                                                    <div className="intro-y g-col-12 g-col-lg-12">
                                                                        <div className="grid columns-12 align-items-center">
                                                                            <div className="g-col-12 g-col-sm-12 border border-gray-300 rounded-2 me-3 p-3">
                                                                                <div className="position-relative text-gray-700 dark-text-gray-300">
                                                                                    <input
                                                                                        type="text"
                                                                                        value={searchTerm}
                                                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                                                        className="form-control py-3 px-4 box border-white dark-border-dark-3 w-full placeholder-theme-13"
                                                                                        placeholder="Search item..."
                                                                                    />
                                                                                    <i className="w-4 h-4 position-absolute my-auto top-0 bottom-0 me-3 end-0" data-feather="search"></i>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            searchTerm &&
                                                                            <div className="grid columns-12 border border-gray-300 rounded-2 mt-3 p-3">
                                                                                <div className="g-col-12 g-col-lg-6 g-col-sm-12">
                                                                                    <label for="crud-form-1" className="form-label fw-medium">Spare Parts :</label>
                                                                                    <div className="p-3 border border-gray-300 rounded-2 h-64 overflow-y-auto">
                                                                                        {
                                                                                            searchTerm && filteredProducts &&
                                                                                            filteredProducts.map((product) => (
                                                                                                product?.product_type === 'goods' ? (
                                                                                                    <div className="m-2 float-start p-1" key={product.id}>
                                                                                                        <button className="btn btn-secondary-outline w-fit-content border border-gray-500" type="button" onClick={() => onClickItem(product)}>
                                                                                                            {product?.name}
                                                                                                        </button>
                                                                                                    </div>
                                                                                                ) : null
                                                                                            ))
                                                                                        }

                                                                                    </div>
                                                                                </div>
                                                                                <div className="g-col-12 g-col-lg-6 g-col-sm-12">
                                                                                    <label for="crud-form-1" className="form-label fw-medium">Repairs :</label>
                                                                                    <div className="p-3 border border-gray-300 rounded-2 h-64 overflow-y-auto">
                                                                                        {
                                                                                            searchTerm && filteredProducts &&
                                                                                            filteredProducts.map((product) => (
                                                                                                product?.product_type === 'service' ? (
                                                                                                    <div className="m-2 float-start p-1" key={product.id}>
                                                                                                        <button className="btn btn-secondary-outline w-fit-content border border-gray-500" type="button" onClick={() => onClickItem(product)}>
                                                                                                            {product?.name}
                                                                                                        </button>
                                                                                                    </div>
                                                                                                ) : null
                                                                                            ))
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="g-col-12 g-col-lg-6 g-col-sm-12 border border-gray-600 rounded-3 p-3">
                                                                <div className="d-flex justify-content-between">
                                                                    <h2 className="fs-lg fw-medium mb-3 ms-2">Estimated Products: </h2>
                                                                    <button onClick={handleShow} type="button" className="bg-transparent w-6 h-6 me-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></button>
                                                                </div>
                                                                <div class="overflow-x-auto border border-gray-600 rounded-3">
                                                                    <table class="table table-striped">
                                                                        <thead>
                                                                            <tr>
                                                                                <th class="text-nowrap"></th>
                                                                                <th class="text-nowrap">Parts</th>
                                                                                <th class="text-nowrap">Type</th>
                                                                                <th class="text-nowrap">Category</th>
                                                                                {
                                                                                    showCost &&
                                                                                    <th class="text-nowrap">Cost (AED)</th>
                                                                                }
                                                                                <th class="text-nowrap">Price (AED)</th>
                                                                                {/* <th class="text-nowrap">Estimated Price (AED)</th> */}
                                                                                <th class="text-nowrap">Quantity</th>
                                                                                <th class="text-nowrap">Total (AED)</th>
                                                                                <th class="text-nowrap">Actions</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                estimateDetails && Object.keys(estimateDetails).length > 0 &&
                                                                                estimateDetails?.detail_show.map((detail, index) => {
                                                                                    const handleCostChange = (e) => {
                                                                                        const newPrice = parseFloat(e.target.value);
                                                                                        const productId = e.target.getAttribute("data-productid");

                                                                                        const updatePurchaseOrder = (updatedDetails) => {
                                                                                            // Check if the product exists in the purchaseOrder state and update it
                                                                                            const updatedPurchaseOrder = purchaseOrders && purchaseOrders.map((p) => {
                                                                                                if (p.product_id == productId) {
                                                                                                    return {
                                                                                                        ...p,
                                                                                                        total_amount: newPrice * p.quantity,
                                                                                                        sale_price: newPrice
                                                                                                    };
                                                                                                }
                                                                                                return p;
                                                                                            });
                                                                                            setPurchaseOrders(updatedPurchaseOrder);
                                                                                        };

                                                                                        if (!isNaN(newPrice)) {
                                                                                            // Make a shallow copy of the detail array
                                                                                            const updatedDetails = estimateDetails.detail_show.map((d) => {
                                                                                                if (d.product_id == productId) {
                                                                                                    // Update the estimated_price for the matching object
                                                                                                    if (!d.price_sold) {
                                                                                                        return {
                                                                                                            ...d,
                                                                                                            total_amount: newPrice * d.quantity,
                                                                                                            sale_price: newPrice
                                                                                                        };
                                                                                                    } else {
                                                                                                        return {
                                                                                                            ...d,
                                                                                                            total_amount: d.price_sold * d.quantity,
                                                                                                            sale_price: newPrice
                                                                                                        };
                                                                                                    }
                                                                                                }
                                                                                                return d;
                                                                                            });

                                                                                            // Update the state with the updated details
                                                                                            setEstimateDetails({
                                                                                                ...estimateDetails,
                                                                                                detail_show: updatedDetails
                                                                                            });

                                                                                            updatePurchaseOrder(updatedDetails);
                                                                                        } else {
                                                                                            // Handle the case when the input is cleared
                                                                                            const updatedDetails = estimateDetails.detail_show.map((d) => {
                                                                                                if (d.product_id == productId) {
                                                                                                    if (!d.price_sold) {
                                                                                                        return {
                                                                                                            ...d,
                                                                                                            total_amount: 0 * d.quantity,
                                                                                                            sale_price: null
                                                                                                        };
                                                                                                    } else {
                                                                                                        return {
                                                                                                            ...d,
                                                                                                            total_amount: d.price_sold * d.quantity,
                                                                                                            sale_price: null
                                                                                                        };
                                                                                                    }
                                                                                                }
                                                                                                return d;
                                                                                            });

                                                                                            setEstimateDetails({
                                                                                                ...estimateDetails,
                                                                                                detail_show: updatedDetails
                                                                                            });

                                                                                            updatePurchaseOrder(updatedDetails);
                                                                                        }
                                                                                    };

                                                                                    const handlePriceChange = (e) => {
                                                                                        const newPrice = parseFloat(e.target.value);
                                                                                        const productId = e.target.getAttribute("data-productid");

                                                                                        const updatePurchaseOrder = (updatedDetails) => {
                                                                                            // Check if the product exists in the purchaseOrder state and update it
                                                                                            const updatedPurchaseOrder = purchaseOrders && purchaseOrders.map((p) => {
                                                                                                if (p.product_id == productId) {
                                                                                                    return {
                                                                                                        ...p,
                                                                                                        price_sold: newPrice,
                                                                                                        total_amount: newPrice * p.quantity
                                                                                                    };
                                                                                                }
                                                                                                return p;
                                                                                            });
                                                                                            setPurchaseOrders(updatedPurchaseOrder);
                                                                                        };

                                                                                        if (!isNaN(newPrice)) {
                                                                                            const updatedDetails = estimateDetails.detail_show.map((d) => {
                                                                                                if (d.product_id == productId) {
                                                                                                    return {
                                                                                                        ...d,
                                                                                                        total_amount: newPrice * d.quantity,
                                                                                                        price_sold: newPrice
                                                                                                    };
                                                                                                }
                                                                                                return d;
                                                                                            });

                                                                                            setEstimateDetails({
                                                                                                ...estimateDetails,
                                                                                                detail_show: updatedDetails
                                                                                            });

                                                                                            updatePurchaseOrder(updatedDetails);
                                                                                        } else {
                                                                                            const updatedDetails = estimateDetails.detail_show.map((d) => {
                                                                                                if (d.product_id == productId) {
                                                                                                    if (!d.sale_price) {
                                                                                                        return {
                                                                                                            ...d,
                                                                                                            total_amount: 0 * d.quantity,
                                                                                                            sale_price: null
                                                                                                        };
                                                                                                    } else {
                                                                                                        return {
                                                                                                            ...d,
                                                                                                            total_amount: d.sale_price * d.quantity,
                                                                                                            price_sold: null
                                                                                                        };
                                                                                                    }
                                                                                                }
                                                                                                return d;
                                                                                            });

                                                                                            setEstimateDetails({
                                                                                                ...estimateDetails,
                                                                                                detail_show: updatedDetails
                                                                                            });

                                                                                            updatePurchaseOrder(updatedDetails);
                                                                                        }
                                                                                    };

                                                                                    return (
                                                                                        <tr>
                                                                                            <td>
                                                                                                <input
                                                                                                    id="checkbox-switch-4"
                                                                                                    className="form-check-input"
                                                                                                    type="checkbox"
                                                                                                    data-product-id={detail?.product_id}
                                                                                                    checked={purchaseOrders ? purchaseOrders.some(order => order.product_id === detail?.product_id) : null}
                                                                                                    onChange={(e) => handleChangePO(e, detail)}
                                                                                                />
                                                                                            </td>

                                                                                            <td>{detail?.product_name}</td>
                                                                                            <td className="text-capitalize">{detail?.product_type === 'spare_parts' ? 'Spare Parts' : detail?.product_type}</td>
                                                                                            <td className="text-uppercase">{detail?.product_category}</td>
                                                                                            {
                                                                                                showCost &&
                                                                                                <td>
                                                                                                    <input
                                                                                                        id={`Price-${index}`}
                                                                                                        name="Cost"
                                                                                                        onChange={handleCostChange}
                                                                                                        type="number"
                                                                                                        step="0.01"
                                                                                                        min={0}
                                                                                                        className="form-control w-20"
                                                                                                        placeholder="Price.."
                                                                                                        value={detail?.sale_price}
                                                                                                        data-productid={detail?.product_id}
                                                                                                    />
                                                                                                </td>
                                                                                            }
                                                                                            <td>
                                                                                                <input
                                                                                                    id={`Price-${index}`}
                                                                                                    name="Price"
                                                                                                    onChange={handlePriceChange}
                                                                                                    type="number"
                                                                                                    step="0.01"
                                                                                                    min={0}
                                                                                                    className="form-control w-20"
                                                                                                    placeholder="Price.."
                                                                                                    value={detail?.price_sold ?? null}
                                                                                                    data-productid={detail?.product_id}
                                                                                                />
                                                                                            </td>
                                                                                            <td><div class="input-group" style={{ width: 110 }}>
                                                                                                <div class="input-group-text cursor-pointer fw-medium" onClick={() => minusQuantityEstimated(index)}>-</div>
                                                                                                <input type="text" class="form-control text-center" value={detail?.quantity} placeholder="Quantity" />
                                                                                                <div onClick={() => addQuantityEstimated(index)} class="input-group-text cursor-pointer fw-medium">+</div>
                                                                                            </div></td>
                                                                                            <td>{detail?.total_amount}</td>
                                                                                            <td><div className="d-flex align-items-center">
                                                                                                <button className="bg-transparent" onClick={(e) => deleteItemEstimate(e, detail, index)} type="button"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-trash-2 text-theme-6 me-2 w-6 h-6"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg> </button>
                                                                                            </div></td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                            <div className="g-col-12 g-col-lg-6 g-col-sm-12 border border-gray-600 rounded-3 p-3">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <h2 className="fs-lg fw-medium mb-3 ms-2">Occured Products: </h2>
                                                                    <div>
                                                                        <h4 className="fw-medium mb-3">Total Cost: {estimateDetails?.job_card_details && estimateDetails?.job_card_details?.reduce((sum, item) => {
                                                                            return sum + (parseFloat(item.sale_price) || 0);
                                                                        }, 0)
                                                                        }</h4>
                                                                        <h4 className="fw-medium mb-3">Total Price: {estimateDetails?.job_card_details && estimateDetails?.job_card_details?.reduce((sum, item) => {
                                                                            return sum + (parseFloat(item.price_sold) || 0);
                                                                        }, 0)
                                                                        }</h4>
                                                                        <h4 className="fw-medium mb-3">Total Amount: {estimateDetails?.job_card_details && estimateDetails?.job_card_details?.reduce((sum, item) => {
                                                                            return sum + (parseFloat(item.total_amount) || 0);
                                                                        }, 0)
                                                                        }</h4>
                                                                    </div>
                                                                </div>
                                                                <div class="overflow-x-auto border border-gray-600 rounded-3">
                                                                    <table class="table table-striped">
                                                                        <thead>
                                                                            <tr>
                                                                                <th class="text-nowrap">Parts</th>
                                                                                <th class="text-nowrap">Type</th>
                                                                                <th class="text-nowrap">Category</th>
                                                                                <th class="text-nowrap">Vendor</th>
                                                                                {
                                                                                    showCost &&
                                                                                    <th class="text-nowrap">Cost (AED)</th>
                                                                                }
                                                                                <th class="text-nowrap">Price (AED)</th>
                                                                                <th class="text-nowrap">Quantity</th>
                                                                                <th class="text-nowrap">Total (AED)</th>
                                                                                <th class="text-nowrap">Actions</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                estimateDetails && Object.keys(estimateDetails).length > 0 && estimateDetails.job_card_details &&
                                                                                estimateDetails?.job_card_details.map((detail, index) => {
                                                                                    const handleCostChange = (e) => {
                                                                                        const newPrice = parseFloat(e.target.value);
                                                                                        if (!isNaN(newPrice)) {
                                                                                            const productId = e.target.getAttribute("data-productid");
                                                                                            const vendor = e.target.getAttribute("data-vendor");

                                                                                            // Make a shallow copy of the detail array
                                                                                            const updatedDetails = estimateDetails.job_card_details.map((d) => {
                                                                                                if (d.product_id == productId) {
                                                                                                    // Update the estimated_price for the matching object
                                                                                                    if (!d.price_sold) {
                                                                                                        return {
                                                                                                            ...d,
                                                                                                            total_amount: newPrice * d.quantity,
                                                                                                            sale_price: newPrice
                                                                                                        };
                                                                                                    } else {
                                                                                                        return {
                                                                                                            ...d,
                                                                                                            total_amount: d.price_sold * d.quantity,
                                                                                                            sale_price: newPrice
                                                                                                        };
                                                                                                    }
                                                                                                }
                                                                                                return d;
                                                                                            });

                                                                                            if (vendor !== null) {
                                                                                                if (estimateDetails.purchase_orders && Object.keys(estimateDetails.purchase_orders).length > 0) {
                                                                                                    // Find the array associated with the specific vendor ID
                                                                                                    const filteredPurchaseOrdersEntry = Object.entries(estimateDetails.purchase_orders).find(([vendorId, orders]) => vendorId === vendor);

                                                                                                    if (filteredPurchaseOrdersEntry) {
                                                                                                        const [, purchaseOrdersArray] = filteredPurchaseOrdersEntry;

                                                                                                        const updatePurchaseOrder = purchaseOrdersArray && purchaseOrdersArray.map((d) => {
                                                                                                            if (d.product_id == productId) {
                                                                                                                // Update the estimated_price for the matching object
                                                                                                                if (!d.price_sold) {
                                                                                                                    return {
                                                                                                                        ...d,
                                                                                                                        total_amount: newPrice * d.quantity,
                                                                                                                        sale_price: newPrice
                                                                                                                    };
                                                                                                                } else {
                                                                                                                    return {
                                                                                                                        ...d,
                                                                                                                        total_amount: d.price_sold * d.quantity,
                                                                                                                        sale_price: newPrice
                                                                                                                    };
                                                                                                                }
                                                                                                            }
                                                                                                            return d;
                                                                                                        });

                                                                                                        // Update the state with the updated details
                                                                                                        setEstimateDetails({
                                                                                                            ...estimateDetails,
                                                                                                            purchase_orders: updatePurchaseOrder,
                                                                                                        });
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            setEstimateDetails({
                                                                                                ...estimateDetails,
                                                                                                job_card_details: updatedDetails,
                                                                                            });
                                                                                        } else {
                                                                                            // Handle the case when the input is cleared
                                                                                            const productId = e.target.getAttribute("data-productid");
                                                                                            const vendor = e.target.getAttribute("data-vendor");

                                                                                            // Make a shallow copy of the detail array
                                                                                            const updatedDetails = estimateDetails.job_card_details.map((d) => {
                                                                                                if (d.product_id == productId) {
                                                                                                    // Set the estimated_price to null for the matching object
                                                                                                    if (!d.price_sold) {
                                                                                                        return {
                                                                                                            ...d,
                                                                                                            total_amount: 0 * d.quantity,
                                                                                                            sale_price: null
                                                                                                        };
                                                                                                    } else {
                                                                                                        return {
                                                                                                            ...d,
                                                                                                            total_amount: d.price_sold * d.quantity,
                                                                                                            sale_price: null
                                                                                                        };
                                                                                                    }
                                                                                                }
                                                                                                return d;
                                                                                            });
                                                                                            if (vendor !== null) {
                                                                                                if (estimateDetails.purchase_orders && Object.keys(estimateDetails.purchase_orders).length > 0) {
                                                                                                    // Find the array associated with the specific vendor ID
                                                                                                    const filteredPurchaseOrdersEntry = Object.entries(estimateDetails.purchase_orders).find(([vendorId, orders]) => vendorId === vendor);

                                                                                                    if (filteredPurchaseOrdersEntry) {
                                                                                                        const [, purchaseOrdersArray] = filteredPurchaseOrdersEntry;

                                                                                                        const updatePurchaseOrder = purchaseOrdersArray && purchaseOrdersArray.map((d) => {
                                                                                                            if (d.product_id == productId) {
                                                                                                                // Update the estimated_price for the matching object
                                                                                                                if (!d.price_sold) {
                                                                                                                    return {
                                                                                                                        ...d,
                                                                                                                        total_amount: 0 * d.quantity,
                                                                                                                        sale_price: null
                                                                                                                    };
                                                                                                                } else {
                                                                                                                    return {
                                                                                                                        ...d,
                                                                                                                        total_amount: d.price_sold * d.quantity,
                                                                                                                        sale_price: null
                                                                                                                    };
                                                                                                                }
                                                                                                            }
                                                                                                            return d;
                                                                                                        });

                                                                                                        // Update the state with the updated details
                                                                                                        setEstimateDetails({
                                                                                                            ...estimateDetails,
                                                                                                            purchase_orders: updatePurchaseOrder,
                                                                                                        });
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            setEstimateDetails({
                                                                                                ...estimateDetails,
                                                                                                job_card_details: updatedDetails,
                                                                                            });
                                                                                        }
                                                                                    };
                                                                                    const handlePriceChange = (e) => {
                                                                                        const newPrice = parseFloat(e.target.value);
                                                                                        const vendor = e.target.getAttribute("data-vendor");

                                                                                        if (!isNaN(newPrice)) {
                                                                                            const productId = e.target.getAttribute("data-productid");

                                                                                            // Make a shallow copy of the detail array
                                                                                            const updatedDetails = estimateDetails.job_card_details.map((d) => {
                                                                                                if (d.product_id == productId) {
                                                                                                    // Update the estimated_price for the matching object
                                                                                                    return {
                                                                                                        ...d,
                                                                                                        total_amount: newPrice * d.quantity,
                                                                                                        price_sold: newPrice
                                                                                                    };
                                                                                                }
                                                                                                return d;
                                                                                            });
                                                                                            if (vendor !== null) {
                                                                                                if (estimateDetails.purchase_orders && Object.keys(estimateDetails.purchase_orders).length > 0) {
                                                                                                    // Find the array associated with the specific vendor ID
                                                                                                    const filteredPurchaseOrdersEntry = Object.entries(estimateDetails.purchase_orders).find(([vendorId, orders]) => vendorId === vendor);

                                                                                                    if (filteredPurchaseOrdersEntry) {
                                                                                                        const [, purchaseOrdersArray] = filteredPurchaseOrdersEntry;

                                                                                                        const updatePurchaseOrder = purchaseOrdersArray && purchaseOrdersArray.map((d) => {
                                                                                                            if (d.product_id == productId) {
                                                                                                                // Update the estimated_price for the matching object
                                                                                                                if (!d.sale_price) {
                                                                                                                    return {
                                                                                                                        ...d,
                                                                                                                        total_amount: newPrice * d.quantity,
                                                                                                                        price_sold: newPrice
                                                                                                                    };
                                                                                                                } else {
                                                                                                                    return {
                                                                                                                        ...d,
                                                                                                                        total_amount: d.sale_price * d.quantity,
                                                                                                                        price_sold: newPrice
                                                                                                                    };
                                                                                                                }
                                                                                                            }
                                                                                                            return d;
                                                                                                        });

                                                                                                        // Update the state with the updated details
                                                                                                        setEstimateDetails({
                                                                                                            ...estimateDetails,
                                                                                                            purchase_orders: updatePurchaseOrder,
                                                                                                        });
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            // Update the state with the updated details
                                                                                            setEstimateDetails({
                                                                                                ...estimateDetails,
                                                                                                job_card_details: updatedDetails,
                                                                                            });
                                                                                        } else {
                                                                                            // Handle the case when the input is cleared
                                                                                            const productId = e.target.getAttribute("data-productid");
                                                                                            const vendor = e.target.getAttribute("data-vendor");

                                                                                            // Make a shallow copy of the detail array
                                                                                            const updatedDetails = estimateDetails.job_card_details.map((d) => {
                                                                                                if (d.product_id == productId) {
                                                                                                    // Set the estimated_price to null for the matching object
                                                                                                    if (!d.sale_price) {
                                                                                                        return {
                                                                                                            ...d,
                                                                                                            total_amount: 0 * d.quantity,
                                                                                                            price_sold: null
                                                                                                        };
                                                                                                    } else {
                                                                                                        return {
                                                                                                            ...d,
                                                                                                            total_amount: d.sale_price * d.quantity,
                                                                                                            price_sold: null
                                                                                                        };
                                                                                                    }
                                                                                                }
                                                                                                return d;
                                                                                            });

                                                                                            if (vendor !== null) {
                                                                                                if (estimateDetails.purchase_orders && Object.keys(estimateDetails.purchase_orders).length > 0) {
                                                                                                    // Find the array associated with the specific vendor ID
                                                                                                    const filteredPurchaseOrdersEntry = Object.entries(estimateDetails.purchase_orders).find(([vendorId, orders]) => vendorId === vendor);

                                                                                                    if (filteredPurchaseOrdersEntry) {
                                                                                                        const [, purchaseOrdersArray] = filteredPurchaseOrdersEntry;

                                                                                                        const updatePurchaseOrder = purchaseOrdersArray && purchaseOrdersArray.map((d) => {
                                                                                                            if (d.product_id == productId) {
                                                                                                                // Update the estimated_price for the matching object
                                                                                                                if (!d.sale_price) {
                                                                                                                    return {
                                                                                                                        ...d,
                                                                                                                        total_amount: 0 * d.quantity,
                                                                                                                        price_sold: null
                                                                                                                    };
                                                                                                                } else {
                                                                                                                    return {
                                                                                                                        ...d,
                                                                                                                        total_amount: d.sale_price * d.quantity,
                                                                                                                        price_sold: null
                                                                                                                    };
                                                                                                                }
                                                                                                            }
                                                                                                            return d;
                                                                                                        });

                                                                                                        // Update the state with the updated details
                                                                                                        setEstimateDetails({
                                                                                                            ...estimateDetails,
                                                                                                            purchase_orders: updatePurchaseOrder,
                                                                                                        });
                                                                                                    }
                                                                                                }
                                                                                            }

                                                                                            // Update the state with the updated details
                                                                                            setEstimateDetails({
                                                                                                ...estimateDetails,
                                                                                                job_card_details: updatedDetails,
                                                                                            });
                                                                                        }
                                                                                    };
                                                                                    return (
                                                                                        <tr>
                                                                                            <td>{detail?.product_name}</td>
                                                                                            <td className="text-capitalize">{detail?.product_type === 'spare_parts' ? 'Spare Parts' : detail?.product_type}</td>
                                                                                            <td className="text-uppercase">{detail?.product_category}</td>
                                                                                            {
                                                                                                detail?.product_category == "Consumable" ?
                                                                                                    <td>
                                                                                                        {/* <Select
                                                                                                    className="z-50 w-32"
                                                                                                    styles={styleSelect}
                                                                                                    value={{ id: detail?.vendor, name: detail?.vendor_name }}
                                                                                                    getOptionLabel={(option) => `${option.name}`}
                                                                                                    filter={createFilter({ ignoreAccents: false })}
                                                                                                    filterOption={createFilter({ ignoreAccents: false })}
                                                                                                    getOptionValue={(option) => `${option.id}`}
                                                                                                    options={suppliers && suppliers.length > 0 ? suppliers : []}
                                                                                                /> */}
                                                                                                        <select name="vendor" className="w-32 form-select" id="">
                                                                                                            <option value="">Please Select</option>
                                                                                                            {suppliers &&
                                                                                                                suppliers.map((supplier) => (
                                                                                                                    <option key={supplier.bo_supplier_id} value={supplier.bo_supplier_id} selected={detail?.vendor == supplier.bo_supplier_id}>
                                                                                                                        {supplier.name}
                                                                                                                    </option>
                                                                                                                ))}
                                                                                                        </select>
                                                                                                    </td> : <td className="text-center">-</td>
                                                                                            }
                                                                                            {
                                                                                                showCost &&
                                                                                                <td>
                                                                                                    <input
                                                                                                        id={`Price-${index}`}
                                                                                                        name="Price"
                                                                                                        onChange={handleCostChange}
                                                                                                        type="number"
                                                                                                        step="0.01"
                                                                                                        min={0}
                                                                                                        className="form-control w-20"
                                                                                                        placeholder="Price.."
                                                                                                        value={detail?.sale_price}
                                                                                                        data-productid={detail.product_id}
                                                                                                        data-vendor={detail?.vendor}
                                                                                                    />
                                                                                                </td>
                                                                                            }
                                                                                            <td>
                                                                                                <input
                                                                                                    id={`Price-${index}`}
                                                                                                    name="Price"
                                                                                                    onChange={handlePriceChange}
                                                                                                    type="number"
                                                                                                    step="0.01"
                                                                                                    min={0}
                                                                                                    className="form-control w-20"
                                                                                                    placeholder="Price.."
                                                                                                    value={detail?.price_sold}
                                                                                                    data-productid={detail.product_id}
                                                                                                    data-vendor={detail?.vendor}
                                                                                                />
                                                                                            </td>
                                                                                            <td><div class="input-group" style={{ width: 110 }}>
                                                                                                <div class="input-group-text cursor-pointer fw-medium" onClick={() => minusQuantityOccured(index)}>-</div>
                                                                                                <input type="text" class="form-control text-center" value={detail?.quantity} placeholder="Quantity" />
                                                                                                <div onClick={() => addQuantityOccured(index)} class="input-group-text cursor-pointer fw-medium">+</div>
                                                                                            </div></td>
                                                                                            <td>{detail?.total_amount}</td>
                                                                                            <td><div className="d-flex align-items-center"><button onClick={(e) => moveToEstimated(e, detail, index)} className="bg-transparent w-6 h-6 me-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg></button>
                                                                                                <button onClick={(e) => deleteItemJobCard(e, detail, index)} className="bg-transparent"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-trash-2 text-theme-6 me-2 w-6 h-6"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg> </button>
                                                                                            </div></td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div className="grid columns-12 gap-4 gap-y-3 mt-3">
                                                                    <div className="intro-y g-col-12 g-col-sm-6">
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <AddProduct />
                                            </div>
                                        }
                                        {
                                            jobOutShow &&
                                            <div className="tab-pane fade show" id="jobOut" role="tabpanel" aria-labelledby="jobOut-tab">
                                                <div className="intro-y">
                                                    <div className="px-5 mt-6 pb-5">
                                                        <div className="g-col-sm-12 d-flex justify-content-end">
                                                            {
                                                                claimNo ?
                                                                    <span>
                                                                        {/* <button type="button" onClick={savePerforma} className="btn btn-primary me-2">Create Performa Invoice</button> */}
                                                                        <button onClick={saveJobOut} disabled={loading ? true : false} type="button" className="btn btn-primary w-32 ">Save</button>
                                                                    </span>
                                                                    :
                                                                    <span className="text-end">
                                                                        <h3 className="fs-base text-theme-6 bg-theme-6-light border border-theme-6 p-3 rounded-2 mb-2">
                                                                            LPO Doesnot Exists.
                                                                        </h3>
                                                                        <button onClick={saveJobOut} disabled={loading ? true : false} type="button" className="btn btn-primary w-32 ">Submit</button>
                                                                    </span>
                                                            }
                                                            {/* <button type="button" className="btn btn-primary w-32 me-1">Print Invoice</button> */}
                                                            {/* <button type="button" className="btn btn-primary w-32 me-1">Print Job Card</button>
                                                    <button type="button" className="btn btn-primary w-32 me-1">Print Estimate</button> */}
                                                        </div>
                                                        <div className="grid columns-12">
                                                            <div className="g-col-12 g-col-sm-12 d-flex justify-content-end align-items-center">
                                                                {/* <h2 className="intro-y fs-lg fw-medium ms-2">
                                                                    Repairs :
                                                                </h2> */}
                                                                {/* <div className="text-end mt-2">
                                                                    <h4 className="text-gray-700">Estimated Profit Margin = AED { parseFloat(estimateDetails?.estimate_total_amount) - parseFloat(estimateDetails.total_amount) ?? null }</h4>
                                                                </div> */}
                                                            </div>
                                                            {/* <div className="intro-y g-col-12 g-col-sm-1">
                                                    <div className="intro-y g-col-12 g-col-sm-2 d-flex flex-column justify-items-center">
                                                        <label for="job_out" className="form-label">Job Out<span className="text-theme-6">*</span> :</label>
                                                        <div className="mt-2">
                                                            <div className="form-check form-switch"> <input id="job_out" value={jobOut?.job_out} name="job_out" className="form-check-input" type="checkbox" /></div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                                <div className="mt-2">
                                                                    <label for="lump_sum" className="form-label">Job Out :</label>
                                                                    <div className="form-check form-switch"> <input id="checkbox-switch-7" checked={jobOut?.job_out} name="job_out" onChange={handleChangeJobOutButton} className="form-check-input" type="checkbox" /></div>
                                                                </div>
                                                                <label for="km_out" className="form-label">KM Out<span className="text-theme-6">*</span> :</label>
                                                                <input id="km_out" value={jobOut.km_out != null ? jobOut.km_out : ''} onChange={handleChangeJobOut} name="km_out" type="number" className="form-control" placeholder="Enter Km Out" />
                                                                <label for="out_mobile" className="form-label mt-3">Out Mobile<span className="text-theme-6">*</span> :</label>
                                                                <input id="out_mobile" value={jobOut?.out_mobile != null ? jobOut.out_mobile : ''} onChange={handleChangeJobOut} name="out_mobile" type="text" className="form-control" placeholder="Enter Out Mobile" />
                                                                <div className="mt-2">
                                                                    <label for="lump_sum" className="form-label">Lump Sum :</label>
                                                                    <div className="form-check form-switch"> <input id="checkbox-switch-7" checked={jobOut?.lump_sum == "1" ? true : false} name="lumpSum" onChange={handleChangeLumSum} className="form-check-input" type="checkbox" /></div>
                                                                </div>
                                                                {/* </div>
                                                <div className="intro-y g-col-12 g-col-sm-3"> */}
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                                <label for="image" className="form-label">Image:</label>
                                                                <section className="container text-center form-control">
                                                                    <aside style={thumbsContainer} className="justify-content-center mb-0">
                                                                        {
                                                                            (jobOutFiles.length == 0) &&
                                                                            <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                                                        }
                                                                        <Swiper
                                                                            slidesPerView={4}
                                                                            scrollbar={{
                                                                                hide: true,
                                                                            }}
                                                                            grid={{
                                                                                rows: 1,
                                                                            }}
                                                                            modules={[Grid, Scrollbar]}
                                                                            className="mySwiper h-full"
                                                                        >
                                                                            {jobOutThumbs}
                                                                        </Swiper>
                                                                    </aside>
                                                                    <div {...getRootPropsJobOut({ className: 'dropzone p-2' })}>
                                                                        <input {...getInputPropsJobOut()} />
                                                                        <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                                                        <div className="btn btn-primary w-25 mt-2">Upload Photos</div>
                                                                    </div>
                                                                </section>
                                                            </div>
                                                            {/* <div className="intro-y g-col-12 g-col-sm-4">
                                                    <label for="pay_type" className="form-label">Pay Type<span className="text-theme-6">*</span> :</label>
                                                    <Select styles={styleSelect} value={selectedPayType} onChange={handleChangePayType} name="pay_type" options={[{ value: 1, label: "Cash" }, { value: 2, label: "Cheque" }, { value: 3, label: "Bank Transfer" }]} />
                                                </div> */}
                                                            <div className="intro-y g-col-12 g-col-sm-12">
                                                                <div class="overflow-x-auto border my-5 border-gray-600 rounded-3">
                                                                    <table class="table table-striped">
                                                                        {
                                                                            jobOut && jobOut?.lump_sum == "1" ?
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th class="text-nowrap">Qty</th>
                                                                                        <th class="text-nowrap">Description</th>
                                                                                        <th class="text-nowrap">Rate</th>
                                                                                        <th class="text-nowrap">Vat @ 5%</th>
                                                                                        <th class="text-nowrap">Amount</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                :
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th class="text-nowrap">S. No</th>
                                                                                        {/* <th class="text-nowrap">Consumed On</th> */}
                                                                                        <th class="text-nowrap">Item</th>
                                                                                        <th class="text-nowrap">Price (AED)</th>
                                                                                        {/* <th class="text-nowrap">Selling Price(AED)</th> */}
                                                                                        <th class="text-nowrap">Quantity</th>
                                                                                        {/* <th class="text-nowrap">Discount (%)</th>
                                                                                <th class="text-nowrap">Discount (AED)</th>
                                                                                <th class="text-nowrap">VAT (%)</th>
                                                                                <th class="text-nowrap">VAT (AED)</th> */}
                                                                                        <th class="text-nowrap">Total Amount (AED)</th>
                                                                                    </tr>
                                                                                </thead>
                                                                        }
                                                                        {
                                                                            jobOut && jobOut?.lump_sum == "1" ?
                                                                                <>
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td className="fs-xs">1</td>
                                                                                            <td className="fs-xs p-2">LUMP SUM WITH CLAIM NO : {claimNo ?? '-'}</td>
                                                                                            <td className="fs-xs">{parseFloat(value).toFixed(2) ?? '0'}</td>
                                                                                            <td className="fs-xs">{vat ? parseFloat(vat).toFixed(2) : '0'}</td>
                                                                                            <td className="fs-xs">{parseFloat(parseFloat(value) + parseFloat(vat)).toFixed(2) ?? '0'}</td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                    <tfoot>
                                                                                        <tr>
                                                                                            <td className="fs-xs text-end" colSpan={'4'}>Pre-Tax :</td>
                                                                                            <td className="fs-xs">{value ? parseFloat(value).toFixed(2) : '0'}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td className="fs-xs text-end" colSpan={'4'}>Excess (-) :</td>
                                                                                            <td className="fs-xs">{excess ? parseFloat(excess).toFixed(2) : '0'}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td className="fs-xs text-end" colSpan={'4'}>Taxable:</td>
                                                                                            <td className="fs-xs">{excess ? parseFloat(parseFloat(value) - parseFloat(excess) ?? 0).toFixed(2) : '0'}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td className="fs-xs text-end" colSpan={'4'}>Vat @ 5% :</td>
                                                                                            <td className="fs-xs">{vat ? parseFloat(vat).toFixed(2) : '0'}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td className="fs-xs fw-bold text-end" colSpan={'4'}>Total :</td>
                                                                                            <td className="fs-xs">{
                                                                                                parseFloat(
                                                                                                    (
                                                                                                        parseFloat(value) || 0
                                                                                                    ) -
                                                                                                    (
                                                                                                        parseFloat(excess) || 0
                                                                                                    ) +
                                                                                                    (
                                                                                                        parseFloat(vat) || 0
                                                                                                    )
                                                                                                ).toFixed(2)
                                                                                                ?? '0'
                                                                                            }
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tfoot>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <tbody>
                                                                                        {
                                                                                            estimateDetails && Object.keys(estimateDetails).length > 0 && estimateDetails.job_card_details &&
                                                                                            estimateDetails?.job_card_details.map((detail, index) => {

                                                                                                return (
                                                                                                    <tr key={detail.product_id}>
                                                                                                        <td>{index + 1}</td>
                                                                                                        {/* <td>{moment(detail?.created_at).format('DD-MM-YYYY')}</td> */}
                                                                                                        <td className="w-full">{detail?.product_name}</td>
                                                                                                        <td>{detail?.price_sold}</td>
                                                                                                        <td>x {detail?.quantity}</td>
                                                                                                        {/* <td>
                                                                                                    <input
                                                                                                        id={`discount-${detail.product_id}`}
                                                                                                        name="discount_percentage"
                                                                                                        type="text"
                                                                                                        value={detail.discount_percentage ? detail.discount_percentage : ''}
                                                                                                        className="form-control w-24"
                                                                                                        placeholder="Discount (%)"
                                                                                                        onChange={handleDiscountPercentageChange}
                                                                                                    />
                                                                                                </td>
                                                                                                <td>
                                                                                                    <input
                                                                                                        id={`discount-${detail.product_id}`}
                                                                                                        name="discount"
                                                                                                        type="text"
                                                                                                        value={detail.discount_amount ? detail.discount_amount : ''}
                                                                                                        className="form-control w-24"
                                                                                                        placeholder="Discount.."
                                                                                                        onChange={handleDiscountAmountChange}
                                                                                                    />
                                                                                                </td>
                                                                                                <td>
                                                                                                    5%
                                                                                                </td>
                                                                                                <td>
                                                                                                    {detail?.vat_amount}
                                                                                                </td> */}
                                                                                                        <td>{detail?.total_amount}</td>
                                                                                                    </tr>
                                                                                                );
                                                                                            })
                                                                                        }
                                                                                    </tbody>
                                                                                    <tfoot>
                                                                                        <tr>
                                                                                            <th className="text-end" colSpan={4}>Total Amount Before Vat (AED)</th>
                                                                                            <td>{jobOut?.total_amount ? jobOut?.total_amount : estimateDetails.total_amount}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <th className="text-end" colSpan={2}>Discount (%)</th>
                                                                                            <td>
                                                                                                <input
                                                                                                    id="discount"
                                                                                                    name="discount_percentage"
                                                                                                    value={jobOut.discount_percentage ? jobOut.discount_percentage : ''}
                                                                                                    type="text"
                                                                                                    className="form-control w-28"
                                                                                                    placeholder="Discount (%)"
                                                                                                    onChange={handleTotalDiscountPercentageChange}
                                                                                                />
                                                                                            </td>
                                                                                            <th className="text-end">Discount (AED)</th>
                                                                                            <td>
                                                                                                <input
                                                                                                    id="discount"
                                                                                                    name="discount"
                                                                                                    value={jobOut.discount ? jobOut.discount : ''}
                                                                                                    type="text"
                                                                                                    className="form-control w-28"
                                                                                                    placeholder="Discount.."
                                                                                                    onChange={handleTotalDiscountAmountChange}
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <th className="text-end" colSpan={2}>Total Vat (%)</th>
                                                                                            <td>
                                                                                                {jobOut.vat_percentage ? jobOut.vat_percentage : ''}
                                                                                            </td>
                                                                                            <th className="text-end">Total Vat (AED)</th>
                                                                                            <td>
                                                                                                {jobOut.vat_amount ? jobOut.vat_amount : ''}
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <th className="text-end" colSpan={4}>Grand Total (AED)</th>
                                                                                            <td>{jobOut.grand_total}</td>
                                                                                        </tr>
                                                                                    </tfoot>
                                                                                </>
                                                                        }
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </span>
                    }
                    {/* <div className="tab-pane fade show" id="summary" role="tabpanel" aria-labelledby="summary-tab">
                    5
                </div> */}
                </div>
                {/* <PoliceReportModal />
            <DrivingLicenseModal />
            <InoviceModal /> */}
                <LpoModal />
                <EditVehicleModal vehicleId={estimateDetails?.estimate?.vehicle_id} />
                <EditCustomerModal customerId={estimateDetails?.customer_id} />

                <Modal show={show} onHide={handleClose} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title className="fw-medium fs-lg">Choose Vendor</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="grid columns-12">
                            <div className="intro-y g-col-12">
                                <label for="police" className="form-label">Vendors :</label>
                                <Select styles={styleSelect} onChange={(e) => setVendor({ bo_supplier_id: e.bo_supplier_id, name: e.name })} getOptionLabel={(option) => `${option.name}`} filter={createFilter({ ignoreAccents: false })} filterOption={createFilter({ ignoreAccents: false })} getOptionValue={(option) => `${option.bo_supplier_id}`} options={suppliers && suppliers.length > 0 ? suppliers : []} />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" onClick={handleMoveButtonClick} className="btn btn-primary w-20">Move</button>
                    </Modal.Footer>
                </Modal>
            </div >
        </span>

    )
}


export default AddJobCard;